<template>
  <div class="home-page">
    <!-- 活動標題與介紹區塊 -->
    <!--
      主視覺背景圖：
      1) 由 Event/get-event-data 回傳的 eventData.mainVisualTemplate 決定
      2) 透過 mainVisualBackgroundStyle 計算後，注入 CSS 變數 --main-visual-bg-image
      3) 若 API 無欄位/空值/不合法，會在計算層自動回退到 001
    -->
    <div class="div-centerY ActiveAllInfo" :style="mainVisualBackgroundStyle">
      <div v-if="isPC" class="ActiveTitle">{{ eventData.name }}</div>
      <div v-else class="ActiveTitle PC div-center" v-html="eventData.name"></div>
      <div class="ActiveInfoDiv oneLine">
        <div class="ActivePic">
          <img class="pic" :src="eventData.bannerImage || defaultBanner" alt="">
        </div>
        <div class="titleContentArea">
          <div class="otherInfoArea">
            <div class="activity-introduction-content" v-html="activityIntroductionHtml"></div>
            <div class="Replenish" v-if="eventData.disclaimer">{{ eventData.disclaimer }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 按鈕區塊 -->
    <div class="oneLine div-center">
      <div :class="['joinButtonArea', !isPC && 'div-center']" v-if="eventData.introUrl">
        <div :class="['joinButton', 'downLoad', 'load', 'whiteColor', 'div-center', isPC && 'PC']">
          <a :href="eventData.introUrl" target="_blank">
            <div class="txt" style="color:white;">
              活動簡介與說明
              <el-icon>
                <ArrowRightBold />
              </el-icon>
            </div>
          </a>
        </div>
      </div>
      <div class="joinButtonArea" v-if="!isSignUpClosed && !isTeacherJoinBlocked && (!isUserLoggedIn || (!isJoin && !shouldHideJoinEntry))"
        @click="BtnFunction('join')">
        <div
          :class="['joinButton', 'whiteColor', 'div-center', ((ActiveStart && isInSignUpStage) ? 'onClick' : ''), 'mar-right', isPC && 'PC']">
          <div class="txt" translate="no">
            {{ isPreSignUp ? "我要預報名" : "我要報名" }}
            <el-icon>
              <ArrowRightBold />
            </el-icon>
          </div>
        </div>
      </div>
      <div class="joinButtonArea" v-if="isUserLoggedIn && (isJoin || shouldHideJoinEntry)" @click="BtnFunction('edit')">
        <div :class="['joinButton', 'whiteColor', 'div-center', 'mar-right', isPC && 'PC']">
          <div class="txt" translate="no">
            新增/管理報名班級
            <el-icon>
              <ArrowRightBold />
            </el-icon>
          </div>
        </div>
      </div>
      <div :class="['joinButtonArea', !isPC && 'div-center']" v-if="isReviewer && eventData.features?.allowReviewer">
        <div :class="['joinButton', 'downLoad', 'load', 'whiteColor', 'div-center', isPC && 'PC']">
          <a href='javascript:void(0)' @click="gotoTeammodel('%2Fhome%2FhtExamMark')">
            <div class="txt" style="color:white;">
              評審閱卷
              <el-icon>
                <ArrowRightBold />
              </el-icon>
            </div>
          </a>
        </div>
      </div>
    </div>

    <!-- 已報名班級區塊 -->
    <div class="div-center">
      <div class="cotentDiv oneLine">
        <div :class="isPC ? 'tableDiv class left' : 'tableDiv left'"
          v-if="isJoin && (classListCtrl || PageStatus !== 0)">
          <div class="dialog-header">
            <span class="title_school" style="margin-left: auto;margin-right: auto;">{{ enrolledSchoolInfo.schoolName
              }}</span>
          </div>
          <div class="between titleDiv">
            <div class="title oneLine div-centerY YUnset">
              <img class="iconPic" src="../../assets/img/other_books.png" alt="">
              已報名班級：
            </div>
            <span class="spanTotal2" v-show="isPC">合計{{ selectedCoursesCount }}班， 預估{{ totalExpStuNum }}人，已有{{
              totalStudents }}人</span>
            <span style="width: 30%;"></span>
            <div class="picButton" @click="BtnFunction('edit')"
              v-if="PageStatus === 1 || (PageStatus === 2 && applyInfoData.length > 0)" v-show="isPC">
              <img class="buttonImg" src="../../assets/img/area-01.png" alt="">
              <div class="pngText div-centerY">
                新增/管理報名班級
              </div>
            </div>
          </div>

          <div v-if="!isPC">
            <!-- 手機版已報名班級列表 -->
            <div class="PhoneArea" v-for="(data, i) in applyInfoData" :key="i">
              <div class="left">
                <span class="title">{{ data.group }}</span>
              </div>
              <div class="between">
                <div class="left">
                  <span style="margin-right:20px">{{ data.course }}</span>
                  <span>{{ data.class }}</span>
                </div>
                <div class="left">
                  <span style="margin-right:20px">人數：{{ data.students }}</span>
                </div>
              </div>
              <div v-if="PageStatus === 2" class="left">
                <div class="stressColor">{{ data.stage }}</div>
              </div>
              <div class="line" v-if="i !== (applyInfoData.length - 1)"></div>
            </div>
          </div>
          <div v-else class="tableArea">
            <!-- 電腦版已報名班級表格 -->
            <table class="scheduleTable">
              <thead>
                <tr>
                  <th>組別</th>
                  <th>班級</th>
                  <th>預估人數</th>
                  <th>實際人數</th>
                  <th v-if="PageStatus === 2">進行階段</th>
                  <th v-if="PageStatus === 2"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in applyInfoData" :key="index">
                  <td>{{ row.group }}</td>
                  <td>{{ row.course }} - {{ row.class }}</td>
                  <td>{{ row.expStuNum }}</td>
                  <td>{{ row.students }}</td>
                  <td v-if="PageStatus === 2">
                    <div class="stressColor">{{ row.stage }}</div>
                  </td>
                  <td v-if="PageStatus === 2" style="text-align: center;">
                    <div @click="gotoTeammodel('%2Fhome%2FprivExam')" class="otheBlueColor" style="cursor: pointer;">
                      詳細數據
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- 得獎名單區塊 - 活動結束後才顯示 -->
    <div class="div-center" v-if="isAwardRevealed && eventData.awards?.length > 0">
      <div class="cotentDiv oneLine">
        <div class="tableDiv right">
          <div class="titleDiv winArea oneLine">
            <div class="title oneLine div-centerY YUnset">
              <img class="iconPic" src="../../assets/img/awards_medal.png" alt="">
              得獎名單：
            </div>
          </div>

          <!-- 電腦版得獎名單 -->
          <div v-if="isPC">
            <div v-if="eventData.awardNotice" style="text-align: left;">
              <div v-html="eventData.awardNotice"></div>
            </div>
            <div :class="i === 0 ? 'winCotent div-centerY' : 'winCotent div-centerY'"
              v-for="(group, i) in eventData.awards" :key="i">
              <div class="ContestTitle isPc oneLine">{{ group.title }}</div>
              <div class="tableCss">
                <el-table :data="group.data">
                  <el-table-column prop="rank" label="排名" width="180">
                    <template #default="scope">
                      <div class="oneLine">
                        <img v-if="scope.row.rank === '1'" class="iconPic"
                          src="../../assets/img/awards/awards_trophy1.png" alt="">
                        <img v-else-if="scope.row.rank === '2'" class="iconPic"
                          src="../../assets/img/awards/awards_trophy2.png" alt="">
                        <img v-else-if="scope.row.rank === '3'" class="iconPic"
                          src="../../assets/img/awards/awards_trophy3.png" alt="">
                        <img v-else-if="scope.row.rank === 'excellent'" class="iconPic"
                          src="../../assets/img/awards/awards_decoration1.png" alt="">
                        <img v-else-if="scope.row.rank === 'Shortlisted'" class="iconPic"
                          src="../../assets/img/awards/awards_decoration2.png" alt="">
                        <span class="otheBlueColor winTxt" v-if="scope.row.rank === '1'">第一名</span>
                        <span class="otheBlueColor winTxt" v-else-if="scope.row.rank === '2'">第二名</span>
                        <span class="otheBlueColor winTxt" v-else-if="scope.row.rank === '3'">第三名</span>
                        <span class="otheBlueColor winTxt" v-else-if="scope.row.rank === 'excellent'">優秀獎</span>
                        <span class="otheBlueColor winTxt" v-else-if="scope.row.rank === 'Shortlisted'">入圍獎</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="school" label="學校" />
                  <el-table-column prop="class" label="班級名稱" width="200" />
                  <el-table-column prop="TName" label="帶隊教師" width="100">
                    <template #default="scope">
                      <div class="otheBlueColor">{{ scope.row.TName }}</div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>

          <!-- 手機版得獎名單 -->
          <div v-else>
            <div v-if="eventData.awardNotice" style="text-align: left;">
              <div v-html="eventData.awardNotice"></div>
            </div>
            <div :class="i === 0 ? 'winCotent div-centerY' : 'winCotent div-centerY'"
              v-for="(group, i) in eventData.awards" :key="i">
              <div class="ContestTitle oneLine">{{ group.title }}</div>
              <div v-for="(item, k) in group.data" :key="k" class="tableCssPhone">
                <div class="Div1 between">
                  <div class="oneLine div-centerY2">
                    <img v-if="item.rank === '1'" class="iconPic" src="../../assets/img/awards/awards_trophy1.png"
                      alt="">
                    <img v-else-if="item.rank === '2'" class="iconPic" src="../../assets/img/awards/awards_trophy2.png"
                      alt="">
                    <img v-else-if="item.rank === '3'" class="iconPic" src="../../assets/img/awards/awards_trophy3.png"
                      alt="">
                    <img v-else-if="item.rank === 'excellent'" class="iconPic"
                      src="../../assets/img/awards/awards_decoration1.png" alt="">
                    <img v-else-if="item.rank === 'Shortlisted'" class="iconPic"
                      src="../../assets/img/awards/awards_decoration2.png" alt="">
                    <span class="otheBlueColor winTxt" v-if="item.rank === '1'">第一名</span>
                    <span class="otheBlueColor winTxt" v-else-if="item.rank === '2'">第二名</span>
                    <span class="otheBlueColor winTxt" v-else-if="item.rank === '3'">第三名</span>
                    <span class="otheBlueColor winTxt" v-else-if="item.rank === 'excellent'">優秀獎</span>
                    <span class="otheBlueColor winTxt" v-else-if="item.rank === 'Shortlisted'">入圍獎</span>
                  </div>
                  <div class="Div2">
                    <div class="left">{{ item.school }}</div>
                    <div class="left">
                      <span class="gray1Color rightSet">{{ item.class }}</span>
                      <span class="otheBlueColor">{{ item.TName }}</span>
                    </div>
                  </div>
                </div>
                <p class="line"></p>
              </div>
            </div>
          </div>
        </div>

        <!-- 優選學校區塊 - 活動結束後才顯示 -->
        <div class="tableDiv right" v-if="eventData.excellentSchools?.length > 0">
          <div class="titleDiv between">
            <div class="title oneLine div-centerY YUnset">
              <img class="iconPic" src="../../assets/img/awards_trophies.png" alt="">
              {{ eventData.excellentSchoolsTitle || '優選學校' }}：
            </div>
          </div>
          <div class="schoolList" :style="isPC ? 'margin-left: 30px' : ''">
            <div class="list" v-for="(school, index) in eventData.excellentSchools" :key="index">
              <img class="iconPic" :src="getStarIcon(index)" alt="">
              {{ school }}
              <img class="iconPic" :src="getStarIcon(index)" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 表單填寫提醒 - 活動結束後才顯示 -->
    <div v-if="isAwardRevealed && eventData.formUrl" class="div-center" style="width: 100%; margin-top: 50px;">
      <div v-if="isPC" class="award-form-notice-pc">
        <div style="font-size: 25px; font-weight: 700; margin-bottom: 20px">
          {{ eventData.formTitle || '請得獎教師務必填寫此表' }} <br /><br />
          <span class="form-link-decoration">📝</span>
          <a :href="eventData.formUrl" style="color: #2d8cf0;" target="_blank">表單連結</a>
          <br /><br />
          <span v-if="eventData.formDeadline">*請於 {{ eventData.formDeadline }} 前回填完此表單，以利活動後續作業</span>
        </div>
      </div>
      <div v-else class="award-form-notice-mobile"
        style="width: 80%; height: 300px; margin-left: 10%; margin-right: 10%;">
        <div class="mobile-notice-text">
          {{ eventData.formTitle || '請得獎教師務必填寫此表' }} <br /><br />
          <span class="form-link-decoration">📝</span>
          <a :href="eventData.formUrl" style="color: #2d8cf0;" target="_blank">表單連結</a>
          <br /><br />
          <div class="deadline-notice" v-if="eventData.formDeadline">
            *請於 {{ eventData.formDeadline }} 前回填完此表單
          </div>
        </div>
      </div>
    </div>

    <!-- 重要時程區塊 -->
    <div class="div-center" style="margin-bottom: 20px;">
      <div class="cotentDiv oneLine">
        <div class="tableDiv right">
          <div class="titleDiv between">
            <div class="title oneLine div-centerY YUnset">
              <img class="iconPic" src="../../assets/img/other_book.png" alt="">
              重要時程：
            </div>
          </div>

          <!-- 手機版時程 -->
          <div v-if="!isPC">
            <div v-for="(data, i) in PlanData" :key="i" class="scheduleArea">
              <div class="between titleArea">
                <div class="oneLine titleSet">
                  <div><span class="otheBlueColor stepName">{{ data.stepName }}</span></div>
                  <div class="current_progress" v-if="data.isNow">※目前活動進度</div>
                </div>
                <div style="font-size: 20px;" v-if="isJoin && PageStatus !== 0">
                  <a :href="data.url" target="_blank" v-if="data.urlOpen && data.url !== ''">
                    <el-icon>
                      <Download />
                    </el-icon>
                  </a>
                </div>
              </div>
              <div class="card">
                <div class="between place">
                  <div>地點：<span v-html="data.location"></span></div>
                </div>
                <div class="between time" style="color:#999">
                  <div>{{ data.startTime }} ~ {{ data.endTime }}</div>
                </div>
                <div class="description" v-html="data.description"></div>
              </div>
              <div class="triangleArea div-center" v-if="i !== (PlanData.length - 1)">
                <div>
                  <div class="triangle"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- 電腦版時程表格 -->
          <div class="tableArea" v-else>
            <table class="scheduleTable">
              <thead>
                <tr>
                  <th>時程</th>
                  <th :style="{ width: isNarrow ? 'auto' : '150px' }">階段</th>
                  <th :style="{ width: isNarrow ? 'auto' : '200px' }">地點</th>
                  <th>說明</th>
                  <th v-if="isJoin && PageStatus !== 0" style="width: 70px;">下載</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in PlanData" :key="index" :class="PlanDataRowClass({ row })">
                  <td>{{ row.startTime }} ~ {{ row.endTime }}</td>
                  <td>
                    <div class="otheBlueColor">{{ row.stepName }}</div>
                    <span v-if="row.isNow" class="current_progress">目前活動進度</span>
                  </td>
                  <td>
                    <div class="info-cell" v-html="row.location"></div>
                  </td>
                  <td>
                    <div class="info-cell" v-html="row.description"></div>
                  </td>
                  <td v-if="isJoin && PageStatus !== 0" style="text-align: center;">
                    <div class="URL" style="font-size: 20px;">
                      <a :href="row.url" target="_blank" v-if="row.urlOpen && row.url !== ''">
                        <el-icon>
                          <Download />
                        </el-icon>
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- 頁尾單位資訊 -->
    <div :class="isPC ? 'footerDiv div-center' : 'footerDiv phone div-center'">
      <div class="txtDiv">
        <!-- <template v-if="eventData.sponsors.supervisor?.length">
          指導單位：{{ eventData.sponsors.supervisor.join('、') }}<br/>
        </template>
        <template v-if="eventData.sponsors.organizer?.length">
          主辦單位：{{ eventData.sponsors.organizer.join('、') }}<br/>
        </template>
        <template v-if="eventData.sponsors.coOrganizer?.length">
          協辦單位：{{ eventData.sponsors.coOrganizer.join('、') }}<br/>
        </template>
        <template v-if="eventData.sponsors.partner?.length">
          合作單位：{{ eventData.sponsors.partner.join('、') }}<br/>
        </template> -->
      </div>
    </div>

    <!-- ========== 對話框區塊 ========== -->

    <!-- 報名視窗 -->
    <el-dialog v-model="dialogSignUpCtrl" class="applyTableDiv div-centerY signup-dialog  create-class-dialog"
      width="40%" top="6vh" style="height: 675px">
      <template #header>
        <div class="dialog-header class-dialog-full-underline class-create-dialog-header">
          <img class="iconPic" src="../../assets/img/bean/bean_02.png" alt="">
          <span class="title">報名活動</span>
        </div>
      </template>
      <div class="signup-form-wrap">
        <!-- 步驟 1：確認報名資訊 -->
        <div class="createClass-step">
          <div class="createClass-step-label"><span class="step-badge">1</span> 確認報名資訊</div>
          <div class="signup-info-group">
            <div class="signup-field-row">
              <span class="signup-field-label">報名學校</span>
              <span class="signup-field-value">{{ userSchool.schoolName }}</span>
            </div>
            <div class="signup-field-row">
              <span class="signup-field-label">{{ courseListDisplayName }}</span>
              <span class="signup-field-value">{{ selectedRow?.name }}</span>
            </div>
          </div>
        </div>

        <!-- 步驟 2：填寫報名資料 -->
        <div class="createClass-step">
          <div class="createClass-step-label"><span class="step-badge">2</span> 填寫報名資料</div>
          <div class="form-item">
            <strong>預估人數：</strong>
            <el-input v-model="selectedRow.expStuNum"
              style="width:100%; --el-input-border-color:#999; --el-input-focus-border-color:#999;" />
          </div>
          <div class="form-item">
            <strong>報名組別：</strong>
            <el-cascader v-model="selectedRow.groupId" :options="groupListOption"
              style="width:100%; --el-input-border-color:#999; --el-input-focus-border-color:#999;" />
          </div>
          <div class="form-item" style="margin-bottom:0">
            <strong>Email 填寫/確認：</strong>
            <el-input v-model="signUpEmail"
              style="width:100%; --el-input-border-color:#999; --el-input-focus-border-color:#999;" />
            <div style="font-size:13px; margin-top:8px; color:#666; line-height:1.7;">
              <div>📌 活動通知將會發送到此，務必填寫能接收到通知的信箱</div>
              <label style="display:flex; align-items:center; gap:6px; cursor:pointer;">
                <input type="checkbox" v-model="isSaveMainEmail" :disabled="isMustSaveMainEmail" />
                將此 Email 作為帳號的主要聯絡信箱
              </label>
            </div>
          </div>
        </div>

        <!-- Action Bar -->
        <div class="signup-dialog-footer">
          <el-button @click="dialogAddClassConfirm()" round type="primary" size="large">送出報名</el-button>
          <el-button @click="dialogSignUpCtrl = false" round type="danger" size="large">取消</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 登入後提示訊息 -->
    <el-dialog v-model="dialogAfterLoginCtrl" width="25%" top="15vh" class="login-dialog">
      <template #header>
        <div class="login-dialog-header">
          <span class="login-dialog-title">{{ eventData.name }}</span>
        </div>
      </template>
      <div class="login-dialog-content">
        <p>您已登入成功！</p>
        <br>
        <div v-if="!isSignUpClosed && isTeacherJoinBlocked">您不在本活動教師清單中，無法報名此活動。</div>
        <div v-else-if="!isSignUpClosed && !shouldHideJoinEntry">如欲報名活動，請點選 <strong>「<a class="a_color"
              @click="BtnFunction('join')">{{ isPreSignUp ? "我要預報名" : "我要報名" }}</a>」</strong> 進行報名。</div>
        <div v-else-if="!isSignUpClosed && shouldHideJoinEntry">此活動為班級名單模式，請點選「新增/管理報名班級」。</div>
        <div v-else>報名時間已結束。</div>
      </div>
    </el-dialog>

    <!-- 手機版登入提示 -->
    <el-dialog v-model="dialogAfterLoginNoPCCtrl" width="90%" top="15vh" class="login-dialog">
      <template #header>
        <div class="login-dialog-header">
          <span class="login-dialog-title">{{ eventData.name }}</span>
        </div>
      </template>
      <div class="login-dialog-content">
        <div>如欲報名活動，請用網頁進行報名。</div>
      </div>
    </el-dialog>

    <!-- 班級管理對話框 -->
    <el-dialog v-model="dialogAddClassCtrl" class="applyTableDiv div-centerY class-create-dialog" width="60%" top="5vh">
      <template #header>
        <div class="dialog-header">
          <img class="iconPic" src="../../assets/img/bean/bean_02.png" alt="">
          <span class="title ">參賽班級管理</span>
        </div>
      </template>
      <div class="content div-center2">
        <div class="info">          
          一、HiTeach軟體安裝與基本操作 <a class="urlCss" href="https://www.habook.com/zh-tw/faq.php?act=view&id=274" target="_blank">GO</a>! 
          <br>
          二、建立名單與官網班級報名畫面
          <a class="urlCss" href="https://www.habook.com/zh-tw/faq.php?act=view&id=263#join" target="_blank">GO</a>!          
          <br>
          三、注意事項<br>
          <div style="margin-left: 28px;">
          如老師遇到不確定「新學期所教班級」之狀況，本次活動在報名時，透過簡易名單，可先填寫預計參加的班級、預估人數，做預報名。<br>
          待後續班級名單確認後，再來重新匯入、編輯學生名單皆是可以的，請師長們放心報名參加！
          </div>

          <!-- 3.如果報名後參賽班級有變動(增加或減少學生)，要再回來此處<b><u>更新資料並重新選擇</u></b>喔！ -->
        </div>
        <div class="school-header" style="text-align: center;">
          <span class="title class-manage-school-underline">
            {{ userSchool.schoolName }}
          </span>
        </div>
        <div class="chooseArea2"
          style="display: flex; justify-content: center; flex-direction: column; align-items: center; gap: 15px;">
          <div
            style="display: flex; justify-content: flex-start; gap: 30px; flex-wrap: wrap; width: 100%; align-items: center;">
            <el-button type="primary" v-if="!isSignUpClosed && !isSchoolClassTeacherTargetMode"
              @click="openCreateClass('crt')">新建簡易名單</el-button>
            <span style="color:#E88847; font-size: 15px; font-weight: 600;">已報名班級總數：{{ selectedCoursesCount }}</span>
            <span style="color:#E88847; font-size: 15px; font-weight: 600;">人數：{{ totalStudents }}</span>
            <span style="color:#E88847; font-size: 15px; font-weight: 600;">預估人數：{{ totalExpStuNum }}</span>
          </div>
        </div>
        <!-- 純 HTML 卡片列表（取代 el-table） -->
        <div class="cardListContainer class-manage-card-list" :class="{ 'hide-edit-column': isSchoolClassTarget }">
          <!-- 表頭 -->
          <div class="cardListHeader">
            <div class="cardColumn col-name">{{ courseListDisplayName }}</div>
            <div class="cardColumn col-students">人數</div>
            <div class="cardColumn col-exp-students">預估人數</div>
            <div v-if="!isSchoolClassTarget" class="cardColumn col-edit">編輯</div>
            <div class="cardColumn col-group">組別</div>
            <div class="cardColumn col-action">操作</div>
          </div>

          <!-- 卡片列表 -->
          <div class="cardListBody">
            <div v-for="(row, index) in applyTableData" :key="index" class="cardRow">
              <!-- 課程名稱列 -->
              <div class="cardColumn col-name">
                <span>{{ row.courseName }} - {{ row.name }}</span>
                <span class="highlight-row status-enrolled"
                  v-show="row.groupId.some((id) => id.toString().trim() !== '')">已報名</span>
              </div>
              <!-- 人數列 -->
              <div class="cardColumn col-students">
                <span>{{ row.students }}人</span>
              </div>
              <!-- 預估人數列 -->
              <div class="cardColumn col-exp-students">
                <span>{{ row.expStuNum }}人</span>
              </div>
              <!-- 編輯簡易名單列 -->
              <div v-if="!isSchoolClassTarget" class="cardColumn col-edit">
                <el-button v-if="row.type === 'simple' && !isAfterFinalStage && !isSchoolClassTeacherTargetMode"
                  type="warning" plain size="small" round @click="openCreateClass('upd', row)">
                  編輯簡易名單
                </el-button>
              </div>
              <!-- 組別列 -->
              <div class="cardColumn col-group">
                <span>{{ getGroupName(row.groupId[0]) }}</span>
              </div>
              <!-- 操作列 -->
              <div class="cardColumn col-action">
                <button v-show="row.groupId[0] !== '' && !isAfterFinalStage" class="btn btn-secondary btn-action-edit"
                  @click="openSelectItem(row)">
                  編輯
                </button>
                <button v-if="row.groupId[0] !== '' && !isAfterFinalStage" class="btn btn-danger btn-action-cancel" @click="cancelConfirm(row)">
                  取消
                </button>
                <button v-else-if="!isSignUpClosed && !isTeacherJoinBlocked" class="btn btn-primary btn-action-signup"
                  @click="openSelectItem(row)">
                  報名
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 新增/變更班級對話框 -->
    <el-dialog v-model="dialogCreateClassCtrl" class="applyTableDiv div-centerY create-class-dialog" style="width: 40%;"
      top="2vh">
      <template #header>
        <div class="dialog-header class-dialog-full-underline class-create-dialog-header">
          <img class="iconPic" src="../../assets/img/bean/bean_02.png" alt="">
          <span class="title">新增/變更參賽班級名單</span>
        </div>
      </template>
      <div class="content div-center2">
        <!-- 步驟 1：填寫班級名稱 -->
        <div class="createClass-step">
          <div class="createClass-step-label"><span class="step-badge">1</span> 填寫班級名稱</div>
          <div class="school-header">
            <div class="createClass-name-row">
              <span class="createClass-course-tag">{{ courseName }}</span>
              <span class="createClass-dash">—</span>
              <el-input v-model="grouplistName" placeholder="請輸入班級名稱，例如：一年一班"
                style="flex:1; max-width:280px; --el-input-border-color:#999999; --el-input-focus-border-color:#999999; --el-input-bg-color:#fff; font-size:15px;" />
            </div>
          </div>
        </div>

        <!-- 步驟 2：輸入學生名單 -->
        <div class="createClass-step">
          <div class="createClass-step-label"><span class="step-badge">2</span> 輸入學生名單</div>
          <div class="info">
            <div class="createClass-hint-body">
              <div class="createClass-hint-text">
                <div>📋 格式：<strong>名字,座號</strong>，每行一位；💡 可直接從 Excel 複製兩欄資料貼上</div>
              </div>
              <div class="createClass-hint-img">
                <img src="./../../assets/img/2024091301.jpg" class="hint-img-zoom"
                  style="max-width:90px; border-radius:6px; border:1px solid #a9cce3;" />
              </div>
            </div>
          </div>
          <div class="createClass-editor">
            <div class="createClass-editor-col">
              <div class="createClass-col-label">貼上名單</div>
              <el-input type="textarea" v-model="studentInput" placeholder="大雄,1
胖虎,2
小夫,3" rows="7" style="width:100%; --el-input-border-color:#999999; --el-input-focus-border-color:#999999;" />
            </div>
            <div class="createClass-editor-arrow">
              <button class="btn btn-primary createClass-add-btn" @click="addStudents">加入 →</button>
            </div>
            <div class="createClass-editor-col">
              <div class="createClass-col-label">確認名單（{{ students.length }} 人）</div>
              <el-table :data="students" border
                style="width:100%; --el-table-border-color:#999999; --el-border-color:#999999;" max-height="200"
                empty-text="尚無學生">
                <el-table-column prop="name" label="名字" />
                <el-table-column prop="seat" label="座號" width="70" />
                <el-table-column label="" width="60">
                  <template #default="scope">
                    <div style="display:flex; justify-content:center;">
                      <el-button type="danger" size="small" @click="deleteStudent(scope.$index)">刪除</el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>

        <!-- 步驟 3：確認送出 -->
        <div class="createClass-step">
          <div class="createClass-step-label"><span class="step-badge">3</span> 確認送出</div>
          <div class="chooseArea2" style="text-align:center; padding: 16px;">
            <el-button type="primary" size="large" @click="submitCourse">確定新增/變更</el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- Loading 狀態 -->
    <div v-if="isLoading" class="loading-overlay">
      <el-icon class="is-loading" :size="50">
        <Loading />
      </el-icon>
      <p>載入活動資料中...</p>
    </div>

  </div>
</template>

<script setup>
import { ref, computed, reactive, onMounted, onUnmounted, watch, inject } from 'vue';
import { useRoute } from 'vue-router';
import { ElMessage, ElMessageBox } from 'element-plus';
import { Loading } from '@element-plus/icons-vue';
import api from '@/api';
import jwtDecode from 'jwt-decode';
import profile from '../../api/profile';
import { Base64 } from 'js-base64';
import router from '../../router';
import { post } from '@/api/http';

// ==================== 路由與活動 ID ====================
const route = useRoute();
const ActivityID = ref('');

const serverLocation = 'global';
const clientID = profile.clientID[serverLocation];
const coreAPIUrl = profile.apiUrl[serverLocation];

// 寫死的活動 ID（開發/展示用）：設為 '' 則從 URL query 取得並呼叫 API
const HARDCODED_EVENT_ID = '';

// ==================== Mock 資料 ====================
const mockEventData = {
  // 測試活動 1 - 閱讀好小子
  'test-event-001': {
    id: 'test-event-001',
    name: '2025 全國閱讀好小子學藝競賽',
    description: `
      <p>本活動參考了
        <a class="a_color" href="https://cirn.moe.edu.tw/WebContent/index.aspx?sid=1199&mid=14127" target="_blank">PISA</a>、
        <a class="a_color" href="https://cirn.moe.edu.tw/Module/index.aspx?sid=1201" target="_blank">PIRLS</a>
        等級的素養文本，並結合專家設計命題，呈現多元且有趣的閱讀素養題型，激發學生的學習興趣。
      </p>
      <p>透過HiTeach教學軟體，可以在課堂上更快速、高效地進行閱讀測驗，讓師生親身體驗科技融入教學的優勢，同時提升生生用平板的應用成效。</p>
      <p>歡迎各班級踴躍參與，共同探索學習新體驗！</p>
    `,
    disclaimer: '*本活動數據將不會作為研究用途',
    bannerImage: '',
    introUrl: '/goodkid',
    loginType: ['tmdId', 'eduId'],
    schedule: [
      { id: 'step1', name: '報名', startTime: 1725206400000, endTime: 1727711999000, location: '線上', description: '開放教師報名參加' },
      { id: 'step2', name: '班級熱身賽', startTime: 1727712000000, endTime: 1728921599000, location: '各校教室', description: '班級進行熱身練習' },
      { id: 'step3', name: '初賽', startTime: 1728921600000, endTime: 1730131199000, location: '各校教室', description: '進行初賽評比' },
      { id: 'step4', name: '決賽', startTime: 1730131200000, endTime: 1769751907910, location: '線上', description: '決賽評比與頒獎' },
    ],
    groups: [
      { id: 'group-low', name: '國小低年級組' },
      { id: 'group-mid', name: '國小中年級組' },
      { id: 'group-high', name: '國小高年級組' },
      { id: 'group-junior', name: '國中組' },
    ],
    features: {
      showAwards: true,
      showExcellentSchools: true,
      showFormReminder: true,
      allowReviewer: true
    },
    awards: [
      {
        title: '低年級組',
        data: [
          { rank: '1', school: '高雄市前金國小', TName: '吳婕鳳', class: '一年二班' },
          { rank: '2', school: '高雄市前金國小', TName: '廖敏娟', class: '二年四班' },
          { rank: '3', school: '高雄市前金國小', TName: '許文華', class: '一年三班' },
          { rank: 'excellent', school: '高雄市前金國小', TName: '陳美靜', class: '一年一班' },
          { rank: 'excellent', school: '南投縣爽文國小', TName: '郭月琴', class: '二年甲班' },
        ]
      },
      {
        title: '中年級組',
        data: [
          { rank: '1', school: '桃園市大華國小', TName: '何世甯', class: '四年一班' },
          { rank: '2', school: '高雄市前金國小', TName: '王珮楹', class: '三年十一班' },
          { rank: '3', school: '高雄市前金國小', TName: '黃姿蓉', class: '四年四班' },
        ]
      },
      {
        title: '高年級組',
        data: [
          { rank: '1', school: '臺中市樹義國小', TName: '段菀翠', class: '五年一班' },
          { rank: '2', school: '雲林縣鎮南國小', TName: '劉文尚', class: '六年一班' },
          { rank: '3', school: '澎湖縣文光國小', TName: '郭訓豪', class: '六年一班' },
        ]
      },
      {
        title: '國中組',
        data: [
          { rank: '1', school: '南投縣三光國中', TName: '蕭秀緞', class: '九年一班' },
          { rank: '2', school: '新北市忠孝國中', TName: '林佳樺', class: '九年五班' },
          { rank: '3', school: '臺北市中崙高中', TName: '陳蕙瑤', class: '八年三班' },
        ]
      }
    ],
    awardNotice: '恭喜以下獲獎班級！頒獎典禮將於近期舉行。',
    excellentSchoolsTitle: '全國閱讀好小子優選學校',
    excellentSchools: [
      '高雄市立前金國小',
      '臺北市立信義國中',
      '新北市立忠孝國中',
      '南投縣立北投國小',
      '臺北市立志清國小'
    ],
    formUrl: 'https://forms.gle/example',
    formTitle: '請得獎教師務必填寫此表',
    formDeadline: '09/17(三)',
    sponsors: {
      supervisor: ['教育部國民及學前教育署'],
      organizer: ['臺灣科技領導與教學科技發展協會', '臺灣讀寫教學研究學會', '小貓頭鷹智慧聯盟校'],
      coOrganizer: ['新竹縣政府教育局', '臺中市政府教育局', '南投縣政府教育處'],
      partner: ['大穎文化事業股份有限公司', '小魯文化事業股份有限公司']
    },
    signUpGuide: `
      一、HiTeach軟體安裝與基本操作 <a class="urlCss" href="https://www.habook.com/zh-tw/faq.php?act=view&id=274" target="_blank">GO</a>! <br>
      二、建立名單與官網班級報名畫面 <a class="urlCss" href="https://www.habook.com/zh-tw/faq.php?act=view&id=263#join" target="_blank">GO</a>! <br>
      三、注意事項：如老師遇到不確定「新學期所教班級」之狀況，本次活動在報名時，透過簡易名單，可先填寫預計參加的班級、預估人數，做預報名。
    `
  },
  
  // 測試活動 2 - 數學競賽
  'test-event-002': {
    id: 'test-event-002',
    name: '2025 全國數學素養挑戰賽',
    description: `
      <p>本活動結合數學素養與邏輯思考，透過有趣的題目設計，培養學生解決問題的能力。</p>
      <p>採用 HiTeach 互動教學系統進行即時評量，讓學習更有效率！</p>
    `,
    disclaimer: '*活動成績僅供參考',
    bannerImage: '',
    introUrl: '/math-challenge',
    loginType: ['tmdId'],
    schedule: [
      { id: 'step1', name: '預報名', startTime: 1725206400000, endTime: 1726415999000, location: '線上', description: '開放預先報名' },
      { id: 'step2', name: '正式報名', startTime: 1726416000000, endTime: 1727711999000, location: '線上', description: '正式報名階段' },
      { id: 'step3', name: '線上競賽', startTime: 1727712000000, endTime: 1728921599000, location: '各校電腦教室', description: '進行線上數學競賽' },
      { id: 'step4', name: '成績公布', startTime: 1728921600000, endTime: 1729525199000, location: '線上', description: '公布成績與頒獎' },
    ],
    groups: [
      { id: 'group-elementary', name: '國小組' },
      { id: 'group-junior', name: '國中組' },
      { id: 'group-senior', name: '高中組' },
    ],
    features: {
      showAwards: true,
      showExcellentSchools: false,
      showFormReminder: true,
      allowReviewer: false
    },
    awards: [
      {
        title: '國小組',
        data: [
          { rank: '1', school: '臺北市大安國小', TName: '王老師', class: '六年一班' },
          { rank: '2', school: '新北市板橋國小', TName: '李老師', class: '五年三班' },
          { rank: '3', school: '桃園市中正國小', TName: '張老師', class: '六年二班' },
        ]
      },
      {
        title: '國中組',
        data: [
          { rank: '1', school: '臺北市建國中學', TName: '陳老師', class: '八年五班' },
          { rank: '2', school: '新北市江翠國中', TName: '林老師', class: '九年一班' },
        ]
      }
    ],
    awardNotice: '',
    excellentSchoolsTitle: '',
    excellentSchools: [],
    formUrl: 'https://forms.gle/math-example',
    formTitle: '請得獎教師填寫領獎資料',
    formDeadline: '10/15(二)',
    sponsors: {
      supervisor: ['教育部'],
      organizer: ['臺灣數學教育學會'],
      coOrganizer: ['各縣市教育局'],
      partner: []
    },
    signUpGuide: `
      一、請先確認已安裝 HiTeach 最新版本<br>
      二、建立班級名單後即可報名參加
    `
  },
  
  // 測試活動 3 - 進行中的活動（可用於測試報名版面）
  'test-event-003': {
    id: 'test-event-003',
    name: '2026 全國英文閱讀素養競賽',
    description: `
      <p>本賽事旨在提升學生英文閱讀理解能力，培養國際競爭力。</p>
      <p>透過多元有趣的英文素材與題型設計，激發學生學習英文的動力。</p>
      <p>歡迎全國各校學生踴躍報名參加！</p>
    `,
    disclaimer: '*本活動報名時程詳見下方時程表',
    bannerImage: '',
    introUrl: '/goodkid',
    loginType: ['tmdId', 'eduId'],
    schedule: [
      { id: 'step1', name: '報名', startTime: 1770000000000, endTime: 1800000000000, location: '線上', description: '開放教師報名參加（目前進行中）' },
      { id: 'step2', name: '初賽', startTime: 1801000000000, endTime: 1810000000000, location: '各校教室', description: '進行初賽評比' },
      { id: 'step3', name: '決賽', startTime: 1811000000000, endTime: 1820000000000, location: '線上', description: '進行決賽評比' },
      { id: 'step4', name: '頒獎', startTime: 1821000000000, endTime: 1830000000000, location: '線上', description: '結果公布與頒獎' },
    ],
    groups: [
      { id: 'group-low', name: '國小低年級組' },
      { id: 'group-mid', name: '國小中年級組' },
      { id: 'group-high', name: '國小高年級組' },
      { id: 'group-junior', name: '國中組' },
      { id: 'group-senior', name: '高中組' },
    ],
    features: {
      showAwards: true,
      showExcellentSchools: true,
      showFormReminder: false,
      allowReviewer: true
    },
    awards: [
      {
        title: '國小高年級組',
        data: [
          { rank: '1', school: '臺北市大安國小', TName: '王美英', class: '六年一班' },
          { rank: '2', school: '新北市板橋國小', TName: '李思語', class: '六年二班' },
          { rank: '3', school: '桃園市中正國小', TName: '張英文', class: '五年三班' },
          { rank: 'excellent', school: '新竹市科學園區小學', TName: '陳語言', class: '六年四班' },
        ]
      },
      {
        title: '國中組',
        data: [
          { rank: '1', school: '臺北市建國中學', TName: '黃老師', class: '八年五班' },
          { rank: '2', school: '新北市江翠國中', TName: '古老師', class: '九年一班' },
          { rank: '3', school: '桃園市武陵高中', TName: '何老師', class: '七年二班' },
        ]
      }
    ],
    awardNotice: '恭喜以下參賽班級獲得佳績！',
    excellentSchoolsTitle: '英文閱讀素養優選學校',
    excellentSchools: [
      '臺北市立大安國小',
      '新北市立板橋國小',
      '桃園市立中正國小',
      '新竹市光武國中'
    ],
    formUrl: '',
    formTitle: '',
    formDeadline: '',
    sponsors: {
      supervisor: ['教育部國民及學前教育署'],
      organizer: ['臺灣英語教育推展協會'],
      coOrganizer: ['各縣市政府教育局處'],
      partner: ['國際英文教材出版社']
    },
    signUpGuide: `
      一、確認已安裝 HiTeach 軟體<br>
      二、建立學生名單（可使用簡易名單功能）<br>
      三、選擇參賽組別並提交<br>
      四、系統將發送確認通知到您的信箱
    `
  }
};

// ==================== 狀態變數 ====================
const isLoading = ref(true);
const eventData = ref({});
const defaultBanner = require('../../assets/img/bean/bean_05.png');

function setPageTitleByEventName(name) {
  const plainName = (name || '').toString().replace(/<[^>]*>/g, '').trim();
  if (!plainName) return;
  document.title = plainName;
}

// 主視覺模板代碼對應圖檔。
// key 必須與後端欄位 mainVisualTemplate 格式一致（001~011），
// 這樣只要改動後端值，前端就能直接切換背景，不需要再改 CSS。
const mainVisualTemplateImages = {
  '001': require('../../assets/img/mainvisual/001.png'),
  '002': require('../../assets/img/mainvisual/002.png'),
  '003': require('../../assets/img/mainvisual/003.png'),
  '004': require('../../assets/img/mainvisual/004.png'),
  '005': require('../../assets/img/mainvisual/005.png'),
  '006': require('../../assets/img/mainvisual/006.png'),
  '007': require('../../assets/img/mainvisual/007.png'),
  '008': require('../../assets/img/mainvisual/008.png'),
  '009': require('../../assets/img/mainvisual/009.png'),
  '010': require('../../assets/img/mainvisual/010.png'),
  '011': require('../../assets/img/mainvisual/011.png')
};

// 星星圖示陣列
const starIcons = [
  require('../../assets/img/symbol_starblue.png'),
  require('../../assets/img/symbol_stargreen.png'),
  require('../../assets/img/symbol_starred.png'),
  require('../../assets/img/symbol_staryellow.png'),
];

const getStarIcon = (index) => starIcons[index % starIcons.length];

// 使用者相關
const isPC = ref(true);
const isReviewer = ref(false);

// 頁面狀態
const ActiveStart = ref(false);
const PageStatus = ref(0); // 0:報名, 1:已報名, 2:活動開跑
const isJoin = ref(false);
const isPreSignUp = ref(false);
const classListCtrl = ref(false);

// 報名相關
const isMustSaveMainEmail = ref(false);
const isSaveMainEmail = ref(false);
const signUpEmail = ref('');
const userSchool = ref({});
const enrolledSchoolInfo = ref({});
const selectedRow = ref(null);

// 使用者資訊
const tmdid = ref('');
const ecName = ref('');
const ecEmail = ref('');
const scope = ref('');
let userSchoolRowData = reactive({});
const signUpClassOptions = reactive([]);
const updateUserInfo = inject("updateUserInfo");

// 組別與課程
const groupListInfo = reactive([]);
const groupListOption = reactive([]);
let signUpGroup = ref([]);
const signUpGroupOptions = reactive([]);
const signUpGroupFun = (value) => {
  const group = signUpGroupOptions.find(item => item.value === value.toString());
  signUpClassOptionsShow.splice(0, signUpClassOptionsShow.length);
  group.signUpClassData.forEach(item => {
    signUpClassOptionsShow.push(item);
  });
};
let signUpClassOptionsShow = reactive([]);
const applyInfoData = reactive([]);
const applyTableData = ref([]);
const schoolClassData = ref({
  teacherTmdids: [],
  courseClassLists: [],
});

// 對話框控制
const dialogSignUpCtrl = ref(false);
const dialogAfterLoginCtrl = ref(false);
const dialogAfterLoginNoPCCtrl = ref(false);
const dialogAddClassCtrl = ref(false);
const dialogCreateClassCtrl = ref(false);

// 班級管理
const courseName = ref('');
const grouplistName = ref('');
const studentInput = ref('');
const students = ref([]);
const upsertMemberMode = ref('');
const originalStudents = ref({});
const signUpClassSelected = ref('');
const groupIdSelected = ref('');

// 時程資料
const PlanData = reactive([]);
const Now_plan = ref('');

// ==================== Computed 屬性 ====================

// 判斷得獎名單是否可以顯示（活動結束後）
const isAwardRevealed = computed(() => {
  if (PlanData.length === 0) return false;
  
  const now = new Date().getTime();
  const lastStep = PlanData[PlanData.length - 1];
  const lastStepEndTime = parseInt(lastStep.stepEndTime);
  
  // 如果有設定專門的公布時間，使用該時間
  if (eventData.value.awardRevealTime) {
    return now > parseInt(eventData.value.awardRevealTime);
  }
  
  return now > lastStepEndTime;
});

// 報名是否已結束
const isSignUpClosed = computed(() => {
  const now = new Date().getTime();
  let latestEndTime = null;
  for (const step of PlanData) {
    if (step.type === 'join' || step.stepName === '報名' || step.stepName === '預報名') {
      const stepEndTime = parseInt(step.stepEndTime);
      if (latestEndTime === null || stepEndTime > latestEndTime) {
        latestEndTime = stepEndTime;
      }
    }
  }
  if (latestEndTime === null) return false;
  return now > latestEndTime;
});

// 判斷當前是否在「報名/預報名」階段（以時程窗口為準）
const isInSignUpStage = computed(() => {
  const now = new Date().getTime();
  return PlanData.some((step) => {
    const isSignUpStep = step.type === 'join' || (step.stepName && step.stepName.includes('報名'));
    if (!isSignUpStep) return false;
    const stepStartTime = parseInt(step.stepStartTime);
    const stepEndTime = parseInt(step.stepEndTime);
    return now >= stepStartTime && now <= stepEndTime;
  });
});

// 是否已進入決賽（examType=custom）階段或之後
const isAfterFinalStage = computed(() => {
  const now = new Date().getTime();
  const finalStageStartTimes = PlanData
    .filter(stepItem => (stepItem.examType || '').toLowerCase() === 'custom')
    .map(stepItem => parseInt(stepItem.stepStartTime))
    .filter(stepStartTime => !Number.isNaN(stepStartTime));

  if (finalStageStartTimes.length === 0) return false;

  const finalStageStartTime = Math.min(...finalStageStartTimes);
  return now >= finalStageStartTime;
});

const isSchoolClassTarget = computed(() => {
  return eventData.value?.target === 'schoolClass';
});

const isUserLoggedIn = computed(() => {
  return !!sessionStorage.getItem('id_token');
});

// 不分活動模式，登入者 tmdid 需存在於學校 teachers.id 清單
const isSchoolClassTeacherMode = computed(() => {
  if (!isUserLoggedIn.value || !tmdid.value) return false;
  const loginId = tmdid.value.toString().trim();
  if (!loginId) return false;
  const teacherIds = schoolClassData.value.teacherTmdids || [];
  return teacherIds.some(item => (item ?? '').toString().trim() === loginId);
});

const hasTeacherWhitelist = computed(() => {
  const teacherIds = schoolClassData.value.teacherTmdids || [];
  return teacherIds.length > 0;
});

// 已登入且活動有教師白名單，但自己不在名單內時，禁止報名
const isTeacherJoinBlocked = computed(() => {
  return isUserLoggedIn.value && hasTeacherWhitelist.value && !isSchoolClassTeacherMode.value;
});

// schoolClass 模式專用：同時命中活動 target 與 teacher 清單
const isSchoolClassTeacherTargetMode = computed(() => {
  return isSchoolClassTarget.value && isSchoolClassTeacherMode.value;
});

const shouldHideJoinEntry = computed(() => {
  // schoolClass 且老師比對命中後，只有「已報名」才隱藏我要報名入口
  return isSchoolClassTeacherTargetMode.value && isJoin.value;
});

const isAIMainVisual = computed(() => {
  const mainVisualType = (eventData.value?.mainVisualType || '').toString().trim().toLowerCase();
  const mainVisualTemplate = (eventData.value?.mainVisualTemplate || '').toString().trim().toUpperCase();
  return mainVisualType === 'ai' || mainVisualTemplate === 'AI';
});

const aiMainVisualImageSource = computed(() => {
  const displayUrl = (eventData.value?.mainVisualAIDisplayUrl || '').toString().trim();
  if (displayUrl) return displayUrl;

  const imageUrl = (eventData.value?.mainVisualAIImageUrl || '').toString().trim();
  if (imageUrl) return imageUrl;

  const imageBase64 = (eventData.value?.mainVisualAIImageBase64 || '').toString().trim();
  if (!imageBase64) return '';

  return imageBase64.startsWith('data:image')
    ? imageBase64
    : `data:image/png;base64,${imageBase64}`;
});

// 將 API 回傳的 mainVisualTemplate 正規化成可用的三位碼模板代號。
const mainVisualTemplateCode = computed(() => {
  const raw = (eventData.value?.mainVisualTemplate ?? '').toString().trim();
  if (!raw) return '001';
  const normalized = raw.padStart(3, '0');
  return mainVisualTemplateImages[normalized] ? normalized : '001';
});

const mainVisualImageSource = computed(() => {
  if (isAIMainVisual.value && aiMainVisualImageSource.value) {
    return aiMainVisualImageSource.value;
  }

  return mainVisualTemplateImages[mainVisualTemplateCode.value] || mainVisualTemplateImages['001'];
});

const mainVisualBackgroundStyle = computed(() => {
  const imgPath = mainVisualImageSource.value || mainVisualTemplateImages['001'];
  return {
    '--main-visual-bg-image': `url(${imgPath})`
  };
});

function sanitizeActivityIntroductionHtml(html) {
  if (!html) return '';
  return html
    .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '')
    .replace(/\son\w+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, '')
    .replace(/href\s*=\s*(["'])\s*javascript:[\s\S]*?\1/gi, 'href="#"');
}

const activityIntroductionHtml = computed(() => {
  const rawHtml =
    (eventData.value?.activityIntroduction || '').toString().trim() ||
    (eventData.value?.description || '').toString().trim();
  return sanitizeActivityIntroductionHtml(rawHtml);
});

const courseListDisplayName = computed(() => {
  return isSchoolClassTeacherTargetMode.value ? '班級名單' : '雲端個人課程名單';
});

// 選擇報名總數
const selectedCoursesCount = computed(() => {
  return signUpGroupOptions.reduce((groupTotal, group) => {
    return groupTotal + group.signUpClassData.reduce((classTotal, signUpClass) => {
      return classTotal + signUpClass.course.filter(course => course.selected).length;
    }, 0);
  }, 0);
});

// 總學生數
const totalStudents = computed(() => {
  return applyTableData.value
    .filter(item => item.groupId.some(id => id.trim() !== ""))
    .reduce((sum, item) => sum + item.students, 0);
});

// 總預估人數
const totalExpStuNum = computed(() => {
  return applyTableData.value
    .filter(item => item.groupId.some(id => id.trim() !== ""))
    .reduce((sum, item) => sum + item.expStuNum, 0);
});

// 視窗寬度判斷
const isNarrow = ref(false);

// ==================== 核心函式 ====================

// 取得活動資料（優先使用本地 mock 資料，否則呼叫 API）
async function fetchEventData(eventId) {
  isLoading.value = true;

  // 優先使用本地 mock 資料（寫死的）
  const localData = mockEventData[eventId];
  if (localData) {
    eventData.value = localData;
    ActivityID.value = localData.id;
    processScheduleData(localData.schedule);
    processGroupData(localData.groups);
    isLoading.value = false;
    return true;
  }

  // 無本地資料，呼叫 API
  try {    
    const res = await api.main.getEventData({ jointEventId: eventId });
    if (res && res.errCode === '' && res.jointEvent) {
      const data = JSON.parse(res.jointEvent);
      eventData.value = data;
      ActivityID.value = data.id;
      scope.value = data.scope || '';
      processScheduleData(data.schedule);
      processGroupData(data.groups);
      isLoading.value = false;
      return true;
    } else {
      ElMessage.error('找不到活動資料，請確認活動 ID 是否正確');
      isLoading.value = false;
      return false;
    }
  } catch (e) {
    ElMessage.error('載入活動資料失敗');
    isLoading.value = false;
    return false;
  }
}

async function syncUserSchoolByEventSchoolId() {
  const schoolId = eventData.value.schoolId || '';
  if (!schoolId) return;

  userSchool.value.schoolId = schoolId;

  try {
    const res = await post(coreAPIUrl + '/service/schoolData', { code: schoolId });
    if (res && res.length > 0) {
      const school = res[0];
      userSchool.value.schoolName = school.name || '';
      userSchool.value.schoolUnitType = school.unitType || '';
      userSchool.value.schoolCountryId = school.countryId || '';
      userSchool.value.schoolCountryName = school.countryName || '';
      userSchool.value.schoolProvinceId = school.provinceId || '';
      userSchool.value.schoolProvinceName = school.provinceName || '';
      userSchool.value.schoolCityId = school.cityId || '';
      userSchool.value.schoolCityName = school.cityName || '';
    }
  } catch (error) {
    console.log('schoolData error', error);
  }
}

async function getSchoolClassDataBySchoolId(schoolId) {
  if (!schoolId) {
    return { teacherTmdids: [], courseClassLists: [] };
  }

  try {
    // 教師白名單維持使用學校資料（判斷登入者是否可報名）
    const schoolResponse = await api.main.getCmuSchoolInfo({ schoolId });
    const schoolPayload = schoolResponse &&
      typeof schoolResponse === 'object' &&
      !Array.isArray(schoolResponse) &&
      schoolResponse.data &&
      typeof schoolResponse.data === 'object' &&
      !Array.isArray(schoolResponse.data)
      ? schoolResponse.data
      : (schoolResponse || {});

    const teachers = Array.isArray(schoolPayload.teachers) ? schoolPayload.teachers : [];
    // 將 teachers.id 正規化為字串陣列，供登入者 id 比對使用
    const teacherTmdids = teachers
      .map((teacher) => (teacher?.id ?? '').toString().trim())
      .filter((id) => id !== '');

    // 班級名單改為從 School container 撈（對齊 get-school-info 邏輯）：
    // 必須傳入 tmid（登入者）與 schoolCode（活動所屬學校）。
    let courseClassLists = [];
    if (tmdid.value) {
      let teacherCourseRes = await api.main.getSchoolCourse({ tmid: tmdid.value, schoolCode: schoolId });
      if (!(teacherCourseRes && Array.isArray(teacherCourseRes.data))) {
        // fallback：若新 API 尚未部署，回退到對齊版個人課程 API。
        teacherCourseRes = await api.main.getIesTeacherCourseAligned({ tmid: tmdid.value });
      }
      const teacherCourseData = Array.isArray(teacherCourseRes?.data) ? teacherCourseRes.data : [];

      courseClassLists = teacherCourseData.map((row, rowIndex) => {
        const courseBase = row?.courseBase || {};
        const courseTasks = Array.isArray(row?.courseTasks) ? row.courseTasks : [];
        const classMap = new Map();

        courseTasks.forEach((task) => {
          const schedules = Array.isArray(task?.schedules) ? task.schedules : [];
          schedules.forEach((schedule, scheduleIndex) => {
            const classId = (schedule?.groupId ?? '').toString().trim();
            if (!classId) return;
            if (classMap.has(classId)) return;

            classMap.set(classId, {
              classId,
              className: schedule?.groupName || `班級${scheduleIndex + 1}`,
              students: Number(schedule?.memberCount ?? 0),
              type: 'schoolClass',
            });
          });
        });

        return {
          courseId: courseBase.id || `course-${rowIndex + 1}`,
          courseName: courseBase.name || `課程${rowIndex + 1}`,
          classLists: Array.from(classMap.values()),
        };
      }).filter((courseItem) => Array.isArray(courseItem.classLists) && courseItem.classLists.length > 0);
    }

    return {
      teacherTmdids,
      courseClassLists,
    };
  } catch (error) {
    console.log('getCmuSchoolInfo error', error);
    return { teacherTmdids: [], courseClassLists: [] };
  }
}

function setSignUpClassOptionsFromSchoolClass(courseClassLists) {
  signUpClassOptions.splice(0, signUpClassOptions.length);
  const gradeName = 'Grade';
  let runCount = 0;

  courseClassLists.forEach((courseItem, courseIndex) => {
    runCount++;
    let course = reactive([]);
    const classLists = Array.isArray(courseItem.classLists) ? courseItem.classLists : [];

    classLists.forEach((classItem, classIndex) => {
      course.push({
        name: classItem.className || classItem.name || `班級${classIndex + 1}`,
        id: classItem.classId || classItem.id || `${courseItem.courseId || `course-${courseIndex + 1}`}-class-${classIndex + 1}`,
        type: classItem.type || 'schoolClass',
        students: Number(classItem.students ?? classItem.memberCount ?? classItem.studentCount ?? 0),
        selected: false,
        expStuNum: Number(classItem.students ?? classItem.memberCount ?? classItem.studentCount ?? 0),
      });
    });

    signUpClassOptions.push({
      value: gradeName + runCount,
      label: courseItem.courseName || courseItem.name || `課程${runCount}`,
      id: courseItem.courseId || courseItem.id || `school-course-${runCount}`,
      course: course,
    });
  });
}

async function initSchoolClassData() {
  // 每次初始化先清空，避免不同活動切換時殘留上一筆學校資料
  schoolClassData.value = { teacherTmdids: [], courseClassLists: [] };
  if (!eventData.value.schoolId) return;

  const schoolData = await getSchoolClassDataBySchoolId(eventData.value.schoolId);
  schoolClassData.value = {
    teacherTmdids: Array.isArray(schoolData.teacherTmdids) ? schoolData.teacherTmdids : [],
    courseClassLists: Array.isArray(schoolData.courseClassLists) ? schoolData.courseClassLists : [],
  };
}

// 處理時程資料
function processScheduleData(schedule) {
  PlanData.splice(0, PlanData.length);
  ActiveStart.value = false;
  PageStatus.value = 0;
  Now_plan.value = '';
  isPreSignUp.value = false;
  
  schedule.forEach((item, index) => {
    const pItem = {
      id: item.id,
      step: index + 1,
      stepStartTime: item.startTime,
      stepEndTime: item.endTime,
      startTime: formatTaiwanDate(item.startTime),
      endTime: formatTaiwanDate(item.endTime),
      stepName: item.name,
      location: item.location,
      description: item.description?.replace(/\n/g, "<br>") || '',
      blobsName: '',
      type: item.type || '',
      examType: item.examType || '',
      url: item.blobs?.[0]?.blob || '',
      urlOpen: false,
      isNow: false,
    };
    PlanData.push(pItem);
  });
  
  // 設定狀態
  const now = new Date().getTime();
  for (let step = 0; step < PlanData.length; step++) {
    const stepStartTime = parseInt(PlanData[step].stepStartTime);
    const stepEndTime = parseInt(PlanData[step].stepEndTime);
    const twoDaysLater = stepStartTime - 2 * 24 * 60 * 60 * 1000;
    
    PlanData[step].urlOpen = (now >= twoDaysLater);
    
    if (now >= stepStartTime) ActiveStart.value = true;
    
    if (now >= stepStartTime && now <= stepEndTime) {
      PlanData[step].isNow = true;
      Now_plan.value = PlanData[step].id;
      if (PlanData[step].stepName === "預報名") {
        isPreSignUp.value = true;
      }
    }
  }

  syncPageStatusByJoinState();
}

function isJoinScheduleStep(stepItem) {
  if (!stepItem) return false;
  // 優先依 type 判斷，並保留舊資料相容（部分活動可能只給階段名稱）
  return stepItem.type === 'join' || stepItem.stepName === '報名' || stepItem.stepName === '預報名';
}

function isNowInJoinSchedule() {
  const now = new Date().getTime();
  return PlanData.some((stepItem) => {
    if (!isJoinScheduleStep(stepItem)) return false;
    const stepStartTime = parseInt(stepItem.stepStartTime);
    const stepEndTime = parseInt(stepItem.stepEndTime);
    if (Number.isNaN(stepStartTime) || Number.isNaN(stepEndTime)) return false;
    return now >= stepStartTime && now <= stepEndTime;
  });
}

function syncPageStatusByJoinState() {
  if (!isNowInJoinSchedule()) {
    PageStatus.value = 2;
    return;
  }

  PageStatus.value = isJoin.value ? 1 : 0;
}

// 處理組別資料
function processGroupData(groups) {
  groupListInfo.splice(0, groupListInfo.length);
  groupListOption.splice(0, groupListOption.length);
  
  groups.forEach((item) => {
    groupListInfo.push({
      name: item.name,
      id: item.id
    });
  });
  
  // 設定組別選項
  groupListOption.push({ label: "請選擇組別...", value: [""] });
  groupListOption.push(...groupListInfo.map(item => ({ value: item.id, label: item.name })));
}

// 格式化日期為民國格式
function formatTaiwanDate(timestamp) {
  const date = new Date(timestamp);
  const year = date.getFullYear() - 1911;
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  return `${year}/${month}/${day} ${hours}:${minutes}`;
}

// 時程表格樣式
const PlanDataRowClass = ({ row }) => {
  if (row.isNow) return 'tableBackground';
  return '';
};

// 取得組別名稱
function getGroupName(groupId) {
  const group = groupListInfo.find(item => item.id === groupId);
  return group ? group.name : '';
}

// ==================== 登入與 API 取報名資料 ====================

async function setLoginInfo() {
  let url = new URL(window.location.href);
  let code = url.searchParams.has("code") ? url.searchParams.get("code") : "";
  if (!sessionStorage.getItem("access_token") && code) {
    await api.main.getToken().then(async (res) => {
      sessionStorage.setItem("id_token", res.id_token);
      sessionStorage.setItem("access_token", res.access_token);
      sessionStorage.setItem("expires_in", res.expires_in);
      const decoded = jwtDecode(res.id_token);
      profile.name = decoded.name;
      profile.teammodelId = decoded.sub;
      profile.picture = decoded.picture;
      sessionStorage.setItem("open_name", decoded.name);
      localStorage.setItem("profile", JSON.stringify({
        name: profile.name,
        id: profile.teammodelId,
        picture: profile.picture,
      }));
    }).catch((error) => {
      console.log(error);
    });
    if (updateUserInfo) {
      updateUserInfo();
    }
    // 換完 token 後，將活動 ID 補回 URL（同時清除 ?code= 避免 OAuth code 殘留在 URL）
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.delete('code');  // 清除已用過的 OAuth code
    const savedId = sessionStorage.getItem('activityEventId');
    if (savedId && !newUrl.searchParams.has('id')) {
      newUrl.searchParams.set('id', savedId);
    }
    location.replace(newUrl.toString());
    return;
  }
}

async function getIes5dataFun() {
  if (isSchoolClassTeacherTargetMode.value) {
    setSignUpClassOptionsFromSchoolClass(schoolClassData.value.courseClassLists || []);
    return;
  }

  let data = { tmid: tmdid.value };
  let res = await api.main.getIesTeacherCourse(data);
  if (res && res.status === 200) res = res.data;
  const gradeName = 'Grade';
  let runCount = 0;
  signUpClassOptions.splice(0, signUpClassOptions.length);
  for (let element of res) {
    runCount++;
    let course = reactive([]);
    if (element.courseTasks.length > 0) {
      for (let item of element.courseTasks[0].schedules) {
        course.push({ name: item.groupName, id: item.groupId, type: item.type, students: item.memberCount, selected: false, expStuNum: 0 });
      }
    }
    signUpClassOptions.push({
      value: gradeName + runCount,
      label: element.courseBase.name,
      id: element.courseBase.id,
      course: course
    });
  }
}

async function getActiveData() {
  if (!ActivityID.value || !tmdid.value) return;
  isJoin.value = false;
  syncPageStatusByJoinState();
  applyInfoData.splice(0, applyInfoData.length);
  signUpGroupOptions.splice(0, signUpGroupOptions.length);

  const groupName = 'Group';
  let runCount = 0;
  for (let element of groupListInfo) {
    runCount++;
    const signUpClassData = JSON.parse(JSON.stringify(signUpClassOptions));
    signUpGroupOptions.push({
      value: groupName + runCount,
      label: element.name,
      GroupId: element.id,
      signUpClassData: signUpClassData
    });
  }

  let joinType = isPreSignUp.value ? "pre" : "regular";
  let data = { jointEventId: ActivityID.value, creatorId: tmdid.value, type: joinType, scope: scope.value };
  let JointCourseData = await api.main.getJointCourseFind(data);

  if (JointCourseData && JointCourseData.data && JointCourseData.data.length !== 0) {
    isJoin.value = true;
    JointCourseData = JointCourseData.data;   
    enrolledSchoolInfo.value = {
      schoolId: userSchool.value.schoolId || '',
      schoolName: userSchool.value.schoolName || ''
    };

    JointCourseData.forEach(res => {
      signUpGroupOptions.forEach(group => {
        if (group.GroupId === res.jointGroupId) {
          if (isSchoolClassTarget.value) {
            const classLists = Array.isArray(res.classLists) ? res.classLists : [];
            if (classLists.length > 0) {
              group.signUpClassData.forEach(classData => {
                classData.course.forEach(courseDetail => {
                  const classInfo = classLists.find((item) => {
                    const classId = (item?.classId || item?.id || '').toString();
                    return classId === (courseDetail.id ?? '').toString();
                  });
                  if (!classInfo) return;

                  courseDetail.selected = true;
                  courseDetail.expStuNum = Number(classInfo.expStuNum ?? courseDetail.expStuNum ?? courseDetail.students ?? 0);

                  let stageData = { name: "", status: "", id: "" };
                  if (Now_plan.value !== '') {
                    stageData = classInfo.schedule?.find(item => item.id === Now_plan.value) || stageData;
                  } else {
                    let planData = getCurrentPlanData();
                    stageData = classInfo.schedule?.find(item => item.id === planData?.id) || stageData;
                  }

                  applyInfoData.push({
                    group: group.label, groupID: group.GroupId,
                    course: classData.label, courseID: classData.id,
                    class: courseDetail.name, classID: courseDetail.id,
                    stage: stageData.name,
                    stageID: stageData.id,
                    stageStatus: stageData.status,
                    students: courseDetail.students,
                    expStuNum: courseDetail.expStuNum
                  });
                });
              });
              return;
            }
          }

          const courseLists = Array.isArray(res.courseLists) ? res.courseLists : [];
          group.signUpClassData.forEach(classData => {
            courseLists.forEach(course => {
              if (classData.id === course.courseId) {
                course.groupLists.forEach(groupList => {
                  classData.course.forEach(courseDetail => {
                    if (courseDetail.id === groupList.id) {
                      courseDetail.selected = true;
                      courseDetail.expStuNum = groupList.expStuNum;
                      let stageData = { name: "", status: "", id: "" };
                      if (Now_plan.value !== '') {
                        stageData = groupList.schedule?.find(item => item.id === Now_plan.value) || stageData;
                      } else {
                        let planData = getCurrentPlanData();
                        stageData = groupList.schedule?.find(item => item.id === planData?.id) || stageData;
                      }
                      applyInfoData.push({
                        group: group.label, groupID: group.GroupId,
                        course: classData.label, courseID: classData.id,
                        class: courseDetail.name, classID: courseDetail.id,
                        stage: stageData.name,
                        stageID: stageData.id,
                        stageStatus: stageData.status,
                        students: courseDetail.students,
                        expStuNum: courseDetail.expStuNum
                      });
                    }
                  });
                });
              }
            });
          });
        }
      });
    });
  } else {
    enrolledSchoolInfo.value = {};
  }

  syncPageStatusByJoinState();
}

async function setJointData() {
  const courseMap = new Map();
  signUpGroupOptions.forEach((group) => {
    group.signUpClassData.forEach((classData) => {
      const matchedCourse = signUpClassOptions.find((c) => c.value === classData.value);
      if (!matchedCourse || !matchedCourse.id) return;
      classData.course.forEach((course) => {
        const key = `${matchedCourse.id}-${course.id}`;
        const existing = courseMap.get(key);
        const groupId = course.selected ? [group.GroupId] : [""];
        const newItem = {
          courseName: matchedCourse.label,
          name: course.name,
          groupId,
          courseId: matchedCourse.id,
          id: course.id,
          students: course.students,
          type: course.type,
          expStuNum: course.expStuNum,
        };
        if (!existing || course.selected) {
          courseMap.set(key, newItem);
        }
      });
    });
  });

  const isChinese = (text) => /[\u4e00-\u9fff]/.test(text);
  applyTableData.value = Array.from(courseMap.values()).sort((a, b) => {
    const aHasGroup = a.groupId.some((id) => id.toString().trim() !== "");
    const bHasGroup = b.groupId.some((id) => id.toString().trim() !== "");
    if (bHasGroup !== aHasGroup) return bHasGroup - aHasGroup;
    const aIsChinese = isChinese(a.name);
    const bIsChinese = isChinese(b.name);
    if (aIsChinese !== bIsChinese) return aIsChinese - bIsChinese;
    return a.name.localeCompare(b.name, "zh-Hant");
  });

  groupListOption.splice(0, groupListOption.length);
  groupListOption.push({ label: "請選擇組別...", value: [""] });
  groupListOption.push(...groupListInfo.map(item => ({ value: item.id, label: item.name })));
}

async function BtnFunction(val, isFromSetSchool) {
  if (!isPC.value) {
    dialogAfterLoginNoPCCtrl.value = true;
    return;
  }

  if (val === 'join' && isSignUpClosed.value) {
    ElMessage({ message: '報名時間已結束，無法進行報名', type: 'warning', duration: 3000 });
    return;
  }

  if (val === 'join' && isTeacherJoinBlocked.value) {
    ElMessage({ message: '您不在本活動教師清單中，無法報名', type: 'warning', duration: 3000 });
    return;
  }

  dialogAfterLoginCtrl.value = false;

  if (val === 'join' && !isFromSetSchool) {
    if (sessionStorage.getItem('open_name')) {
      // 已登入：直接進入報名流程（學校已由 get-event-data 自動設定）
      signUpTableDataSort();
    } else {
      // 未登入：導向登入
      sessionStorage.setItem('info', 'Activity_Event');
      sessionStorage.setItem('activityEventId', eventData.value.id || '');
      if (eventData.value.loginType?.includes('tmdId')) {
        if (eventData.value.loginType.includes('eduId')) {
          router.push({ path: '/Activity_CheckLogin', query: { eid: encodeURIComponent(Base64.encode(eventData.value.id)) } });
        } else {
          api.main.loginTmdID();
        }
      } else {
        let urlhost = location.host === 'localhost:5005' ? 'testHT.teammodel.net' : location.host;
        let data = {
          client_id: profile.clientID['global'],
          op_redirecturi: 'https://' + urlhost + '/Binding_CheckAccount'
        };
        let datastr = encodeURIComponent(Base64.encode(JSON.stringify(data)));
        let url = 'https://oidc.tanet.edu.tw/oidc/v1/azp?response_type=code&client_id=c58722f58275a8c81fcc5ed6b94f3e7b&redirect_uri=https://account.teammodel.net/&scope=openid+email+profile+eduinfo&state=' + datastr + '&nonce=aaaaa';
        location.href = url;
      }
    }
  } else {
    signUpTableDataSort();
  }
}

function signUpTableDataSort() {
  dialogAddClassCtrl.value = true;
  const isChinese = (text) => /[\u4e00-\u9fff]/.test(text);
  applyTableData.value.sort((a, b) => {
    const aHasGroup = a.groupId.some((id) => id.toString().trim() !== '');
    const bHasGroup = b.groupId.some((id) => id.toString().trim() !== '');
    if (bHasGroup !== aHasGroup) return bHasGroup - aHasGroup;
    const aIsChinese = isChinese(a.name);
    const bIsChinese = isChinese(b.name);
    if (aIsChinese !== bIsChinese) return aIsChinese - bIsChinese;
    return a.name.localeCompare(b.name, 'zh-Hant');
  });
}

function openSelectItem(rowItem) {  
  const isCurrentRowJoined = Array.isArray(rowItem?.groupId) && rowItem.groupId[0] !== '';
  if (isTeacherJoinBlocked.value && !isCurrentRowJoined) {
    ElMessage({ message: '您不在本活動教師清單中，無法報名', type: 'warning', duration: 3000 });
    return;
  }

  dialogSignUpCtrl.value = true;
  selectedRow.value = JSON.parse(JSON.stringify(rowItem));
}

function openCreateClass(mode, scopeRow) {
  courseName.value = "HiTeach";
  grouplistName.value = "";
  studentInput.value = "";
  students.value = [];
  groupIdSelected.value = "";
  upsertMemberMode.value = mode;

  // 清空原始學生資料
  originalStudents.value = {};

  if (mode == 'upd') { //變更編輯成員
    signUpClassSelected.value = scopeRow.id;
    groupIdSelected.value = scopeRow.id;
    courseName.value = scopeRow.courseName;
    grouplistName.value = scopeRow.name;
    let data = { grant_type: 'private', stulist_id: scopeRow.id };
    api.main.getStudentsList(data).then(function (result) {
      if (result.students.length > 0) {
        result.students.forEach(function (s) {
          let name = (s.name != null && s.name !== "") ? s.name : (s.nickname != null && s.nickname !== "") ? s.nickname : "";
          let dataRow = name + "," + s.no + "\n";
          studentInput.value += dataRow;

          // 儲存原始學生資料到元件內的 ref
          if (s.id) {
            const key = `${name.trim()}_${s.no.trim()}`;
            originalStudents.value[key] = s;
          }
        });
      }
      addStudents();
      dialogCreateClassCtrl.value = true;
    });
  } else { //新增班級
    dialogCreateClassCtrl.value = true;
  }
}

function addStudents() {
  students.value = [];
  const lines = studentInput.value.split('\n');
  const newStudents = [];
  
  for (const line of lines) {
    if (line && line !== "") {
      const [name, seat] = line.split(/[\t,]/);
      if (!/^\d+$/.test(seat)) {
        ElMessage.error("格式錯誤，請檢查名字及座號欄位是否正確");
        return;
      }
      if (newStudents.some(student => student.seat === seat)) {
        ElMessage.error(`姓名: ${name} 座號: ${seat} 已經存在！`);
        continue;
      }
      newStudents.push({ name, seat });
    }
  }
  students.value.push(...newStudents);
}

function deleteStudent(index) {
  students.value.splice(index, 1);
  ElMessage.success('學生已刪除');
}

watch(studentInput, (newValue) => {
  studentInput.value = newValue.replace(/\t/g, ",");
});

watch(
  () => eventData.value?.name,
  (newName) => {
    setPageTitleByEventName(newName);
  }
);

const submitCourse = async () => {
  //新建班級才驗標題
  if (upsertMemberMode.value == 'crt') {
    if (!grouplistName.value || students.value.length === 0) {
      ElMessage.error('請輸入課程名稱並添加學生！')
      return
    }
  }

  let members = [];
  students.value.forEach((item) => {
    let studentId = "";
    const key = `${item.name.trim()}_${item.seat.trim()}`;
    if (originalStudents.value[key]) {
      studentId = originalStudents.value[key].id || "";
    }

    let mitem = {
      id: studentId,
      code: null,
      type: 3,
      nickname: item.name,
      no: item.seat,
      irs: item.seat
    }
    members.push(mitem);
  });
  let courseId = (upsertMemberMode.value == 'upd') ? signUpClassSelected.value : ""
  let data = {
    courseName: courseName.value,
    groupListName: grouplistName.value,
    limitCount: 200,
    courseId: courseId,
    groupId: groupIdSelected.value,
    member: members,
  };
  let JointCourseData = "";
  if (upsertMemberMode.value == 'crt') {
    JointCourseData = await api.main.setJointCourseUpsertPlus(data);
  } else if (upsertMemberMode.value == 'upd') {
    JointCourseData = await api.main.updJointCourseUpsertPlus(data);
  }

  if (JointCourseData) {
    await updateDataFun()
    await getActiveData()
    await setJointData()

    let msg = (upsertMemberMode.value == 'crt') ? '新增參賽班級名單成功！' : '變更參賽班級名單成功！'
    await ElMessage.success(msg)
    if (upsertMemberMode.value === 'crt') {
      let newClassItem = applyTableData.value.find(item => item.id === JointCourseData.groupId)
      openSelectItem(newClassItem)
    }
    dialogCreateClassCtrl.value = false
    students.value.splice(0, students.value.length)
    courseName.value = ""
    grouplistName.value = ""
    studentInput.value = ""
  }
}

async function updateDataFun() {
  applyTableData.value = [];
  signUpClassOptions.length = 0;
  await getIes5dataFun();
  signUpGroupOptions.length = 0;
  const groupName = 'Group';
  let runCount = 0;
  for (let element of groupListInfo) {
    runCount++;
    const signUpClassData = JSON.parse(JSON.stringify(signUpClassOptions));
    signUpGroupOptions.push({ value: groupName + runCount, label: element.name, GroupId: element.id, signUpClassData: signUpClassData });
  }
  if (signUpGroup.value.length > 0) signUpGroupFun(signUpGroup.value);
}

function getCurrentPlanData() {
  const now = new Date().getTime();
  let currentPlan = PlanData[PlanData.length - 1];
  for (let i = 0; i < PlanData.length; i++) {
    const stepStartTime = parseInt(PlanData[i].stepStartTime);
    const stepEndTime = parseInt(PlanData[i].stepEndTime);
    if (now >= stepStartTime && now <= stepEndTime) {
      currentPlan = PlanData[i];
      break;
    } else if (i > 0 && now < stepStartTime) {
      currentPlan = PlanData[i - 1];
      break;
    }
  }
  return currentPlan;
}

async function dialogAddClassConfirm(rowItem) { 
  if (rowItem) {
    // 取消流程
    rowItem.expStuNum = 0;
    rowItem.groupId[0] = "";
  } else {
    const selectedItem = applyTableData.value.find(item => item.id === selectedRow.value?.id);
    const isCurrentRowJoined = Array.isArray(selectedItem?.groupId) && selectedItem.groupId[0] !== "";
    if (isTeacherJoinBlocked.value && !isCurrentRowJoined) {
      ElMessage({ type: 'warning', message: '您不在本活動教師清單中，無法報名！' });
      return;
    }

    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    // 報名流程
    if (selectedRow.value.expStuNum === "" || selectedRow.value.expStuNum === 0) {
      ElMessage({ type: 'error', message: '請輸入預估人數！' });
      return;
    } else if (selectedRow.value.groupId[0] === "") {
      ElMessage({ type: 'error', message: '請選擇『報名組別』！' });
      return;
    } else if (!signUpEmail.value) {
      ElMessage({ type: 'error', message: '請輸入 Email！' });
      return;
    } else if (!emailPattern.test(signUpEmail.value)) {
      ElMessage({ type: 'error', message: '請輸入有效的 Email 格式！' });
      return;
    } else {
      let selectItem = applyTableData.value.find(item => item.id === selectedRow.value.id);
      if (selectItem) {
        selectItem.expStuNum = parseInt(selectedRow.value.expStuNum);
        selectItem.groupId[0] = selectedRow.value.groupId[0];
      } else {
        return;
      }
    }
  }

  if (userSchool.value.mail === "" || isSaveMainEmail.value) {
    let data = {
      name: sessionStorage.getItem("open_name"),
      grant_type: "add",
      id_token: sessionStorage.getItem("id_token"),
      lang: "zh-tw",
      schoolCode: userSchool.value.schoolId,
      unitType: userSchool.value.schoolUnitType,
      unitName: userSchool.value.schoolName,
      mail: signUpEmail.value.trim()
    };
    post(coreAPIUrl + '/oauth2/Contact', data).then(async res => {
      if (res && res.status && res.status === 200) {
        console.log("API success", res);
      } else {
        console.log("API error", res);
        return;
      }
    });
  }

  // 先清除原本的全部選項
  signUpGroupOptions.forEach((group) => {
    group.signUpClassData.forEach((classData) => {
      classData.course.forEach((course) => {
        course.selected = false;
      });
    });
  });

  // 處理 signUpGroupOptions 把 applyTableData groupId有值的轉移過去
  applyTableData.value.forEach((item1) => {
    signUpGroupOptions.forEach((group) => {
      if (group.GroupId === item1.groupId[0]) {
        group.signUpClassData.forEach((classData) => {
          classData.course.forEach((course) => {
            if (course.id === item1.id) {
              course.selected = true;
              course.expStuNum = item1.expStuNum;
            }
          });
        });
      }
    });
  });

  classListCtrl.value = true;

  if (isInSignUpStage.value && !isJoin.value) {
    isJoin.value = true;
    syncPageStatusByJoinState();
    if (!isPreSignUp.value ) {
      let coupon = api.main.getCoupon(window.location.pathname);
      if (coupon) {
        let ApplyCouponData = {
          id_token: sessionStorage.getItem("id_token"),
          coupon: coupon
        };
        await post(coreAPIUrl + '/oauth2/ApplyCoupon', ApplyCouponData).then(async res => {
          if (res && res.message) {
            ElMessage({ message: "已經報名過該活動", type: 'warning' });
          }
        });
      }
    }
  }

  let applyInfoDataTemp = reactive([]);
  for (let element of signUpGroupOptions) {
    const courseLists = element.signUpClassData.reduce((acc, classData) => {
      const selectedCourses = classData.course.filter(course => course.selected);
      if (selectedCourses.length > 0) {
        selectedCourses.forEach(course => {
          acc.push({
            subjectId: null,
            courseId: classData.id,
            courseName: classData.label,
            groupLists: [{
              id: course.id,
              name: course.name,
              expStuNum: course.expStuNum
            }]
          });
        });
      }
      return acc;
    }, []);
    const classLists = element.signUpClassData.reduce((acc, classData) => {
      const selectedCourses = classData.course.filter(course => course.selected);
      if (selectedCourses.length > 0) {
        selectedCourses.forEach(course => {
          acc.push({
            subjectId: null,
            classId: course.id,
            className: course.name,
            expStuNum: Number(course.expStuNum ?? 0),
          });
        });
      }
      return acc;
    }, []);

    const useClassLists = isSchoolClassTarget.value;
    const selectedPayloadLength = useClassLists ? classLists.length : courseLists.length;
    const isFind = applyInfoData.find(item => item.groupID === element.GroupId);
    if (selectedPayloadLength > 0 || isFind) {
      let userSchoolId = "";
      let userschoolName = "";
      let schoolCountryId = "";
      let schoolCountryName = "";
      let schoolProvinceId = "";
      let schoolProvinceName = "";
      let schoolCityId = "";
      let schoolCityName = "";
      if (sessionStorage.getItem("shortCode")) { userSchoolId = sessionStorage.getItem("shortCode"); }
      else if (userSchool.value.schoolId) { userSchoolId = userSchool.value.schoolId; }
      if (sessionStorage.getItem("school_name")) { userschoolName = sessionStorage.getItem("school_name"); }
      else if (userSchool.value.schoolName) { userschoolName = userSchool.value.schoolName; }
      if (sessionStorage.getItem("countryId")) { schoolCountryId = sessionStorage.getItem("countryId"); }
      else if (userSchool.value.schoolCountryId) { schoolCountryId = userSchool.value.schoolCountryId; }
      if (sessionStorage.getItem("countryName")) { schoolCountryName = sessionStorage.getItem("countryName"); }
      else if (userSchool.value.schoolCountryName) { schoolCountryName = userSchool.value.schoolCountryName; }
      if (sessionStorage.getItem("provinceId")) { schoolProvinceId = sessionStorage.getItem("provinceId"); }
      else if (userSchool.value.schoolProvinceId) { schoolProvinceId = userSchool.value.schoolProvinceId; }
      if (sessionStorage.getItem("provinceName")) { schoolProvinceName = sessionStorage.getItem("provinceName"); }
      else if (userSchool.value.schoolProvinceName) { schoolProvinceName = userSchool.value.schoolProvinceName; }
      if (sessionStorage.getItem("cityId")) { schoolCityId = sessionStorage.getItem("cityId"); }
      else if (userSchool.value.schoolCityId) { schoolCityId = userSchool.value.schoolCityId; }
      if (sessionStorage.getItem("region_name")) { schoolCityName = sessionStorage.getItem("region_name"); }
      else if (userSchool.value.schoolCityName) { schoolCityName = userSchool.value.schoolCityName; }
      let joinType = isPreSignUp.value ? "pre" : "regular";

      let data = {
        jointEventId: ActivityID.value,
        jointGroupId: element.GroupId,
        creatorId: tmdid.value,
        creatorName: ecName.value,
        creatorEmail: signUpEmail.value.trim(),
        schoolId: userSchoolId,
        schoolName: userschoolName,
        countryId: schoolCountryId,
        countryName: schoolCountryName,
        provinceId: schoolProvinceId,
        provinceName: schoolProvinceName,
        cityId: schoolCityId,
        cityName: schoolCityName,
        type: joinType,
        scope: scope.value,
      };

      // JointCourseUpsert 會依活動 target 判斷 classLists 或 courseLists
      if (useClassLists) {
        data.classLists = classLists;
      } else {
        data.courseLists = courseLists;
      }

      try {
        let JointCourseData = await api.main.setJointCourseUpsert(data);
        if (!JointCourseData) {
          throw new Error('報名 API 無回應');
        }
        if (JointCourseData.errCode) {
          // errCode 有值（非空字串）→ API 回傳錯誤
          throw new Error(JointCourseData.err || '報名 API 回傳錯誤');
        }
        // errCode === '' 或不存在 → 成功（含取消: {"errCode":"","err":"","jointCourse":{}} 與報名: {"errCode":"","err":""}）
        if (!rowItem) {
          // 報名成功流程：所有後續處理包在獨立 try-catch，避免任何例外觸發外層「報名失敗」訊息
          try {
            enrolledSchoolInfo.value.schoolId = userSchool.value.schoolId || enrolledSchoolInfo.value.schoolId || '';
            enrolledSchoolInfo.value.schoolName = userSchool.value.schoolName || enrolledSchoolInfo.value.schoolName || '';

            if (useClassLists) {
              if (classLists.length > 0) {
                for (let classData of classLists) {
                  const parentCourse = element.signUpClassData.find((grade) =>
                    grade.course.some(course => course.id === classData.classId)
                  );
                  const selectedClass = parentCourse?.course.find(course => course.id === classData.classId);
                  applyInfoDataTemp.push({
                    group: element.label, groupID: element.GroupId,
                    course: parentCourse?.label || '', courseID: parentCourse?.id || '',
                    class: classData.className, classID: classData.classId,
                    expStuNum: selectedClass?.expStuNum ?? 0,
                    students: selectedClass?.students ?? 0,
                  });
                }
              }
            } else {
              if (courseLists.length > 0) {
                for (let CourseData of courseLists) {
                  for (let classData of CourseData.groupLists) {
                    let students = element.signUpClassData.flatMap(grade => grade.course).find(course => course.id === classData.id)?.students ?? 0;
                    applyInfoDataTemp.push({
                      group: element.label, groupID: element.GroupId,
                      course: CourseData.courseName, courseID: CourseData.courseId,
                      class: classData.name, classID: classData.id,
                      expStuNum: classData.expStuNum,
                      students: students,
                    });
                  }
                }
              }
            }

          } catch (successHandlerError) {
            //console.error('報名成功後處理錯誤（不影響報名結果）:', successHandlerError);
          }
        }
        // 取消成功流程（rowItem 存在）：API 已刪除資料，本地狀態已在前面清除，無需額外處理
      } catch (error) {
        //console.error('報名失敗:', error);
        ElMessage({ type: 'error', message: '報名失敗，請稍後再試' });
        return;
      }
    }
  }

  // 全部 upsert 完成後才寄送一次報名確認 Email，避免統計遺漏後續組別
  if (!rowItem) {
    try {
      let sendMail = signUpEmail.value.trim();
      let localeProfile = JSON.parse(localStorage.getItem("profile")) || {};
      let sendName = ecName.value || localeProfile.name || "";
      if (sendMail && sendName) {
        let joinType = isPreSignUp.value ? "pre" : "regular";
        let sentEmailData = {
          type: "join",
          joinType: joinType,
          mail: sendMail,
          name: sendName,
          creatorId: tmdid.value,
          jointEventId: ActivityID.value,
          courseId: selectedRow.value.courseId,
          groupId: selectedRow.value.id,
          scope: scope.value || eventData.value.scope || 'private',
          target: eventData.value?.target || '',
          classId: selectedRow.value.id,
        };
        await api.main.ActivitySentEmail(sentEmailData);
        console.log('Email sent successfully');
      }
    } catch (emailError) {
      //console.error('Failed to send email:', emailError);
    }
  }

  dialogSignUpCtrl.value = false;
  applyInfoData.splice(0, applyInfoData.length, ...applyInfoDataTemp);
}

const cancelConfirm = (rowItem) => {
  ElMessageBox.confirm(
    '確定要取消報名？',
    '取消報名',
    {
      confirmButtonText: '確定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  ).then(() => {
    dialogAddClassConfirm(rowItem);
    ElMessage({ type: 'success', message: '報名已取消' });
  }).catch(() => {});
}

function gotoTeammodel(target) {
  if (tmdid.value !== '' && sessionStorage.getItem('id_token')) {
    let data = {
      grant_type: 'code',
      client_id: clientID,
      nonce: '0',
      id_token: sessionStorage.getItem('id_token')
    };
    post(coreAPIUrl + '/oauth2/login', data).then(async res => {
      if (res && res.code) {
        let urlhost = api.main.geties5ApiUrl();
        let websirtPart2 = urlhost + '/login/?code=' + res.code + '&identity=teacher&target=' + target;
        window.open(websirtPart2, '_blank');
      }
    });
  } else {
    ElMessage({ type: 'error', message: '請先登入' });
  }
}

// ==================== 生命週期 ====================

const handleResize = () => {
  isNarrow.value = window.innerWidth < 768;
  isPC.value = window.innerWidth >= 768;
};

onMounted(async () => {
  window.addEventListener('resize', handleResize);
  handleResize();
  
  // 寫死的 ID 優先；若為空則從 URL query 取得；最後從 sessionStorage fallback（eduId OAuth 流程導回後 URL 無 ?id=）
  const eventId = HARDCODED_EVENT_ID || route.query.id || sessionStorage.getItem('activityEventId');

  // 若 URL 沒有 ?id= 但有活動 ID，靜默補上（用 history.replaceState 不觸發 vue-router watch，避免重複呼叫 fetchEventData）
  if (eventId && !route.query.id) {
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.set('id', eventId);
    history.replaceState(null, '', newUrl.toString());
  }

  // 先檢查是否需要登入作業
  await setLoginInfo();

  // 清理 URL：移除 OIDC 回調後殘留的多餘參數（如 state, session_state, clientId 等），只保留 ?id=
  // 此清理在 setLoginInfo 之後執行，若有 ?code= 的 OAuth 流程則已 redirect 離開，不會執行到這裡
  {
    const urlToClean = new URL(window.location.href);
    const hasExtraParams = Array.from(urlToClean.searchParams.keys()).some(k => k !== 'id');
    if (hasExtraParams) {
      const activityIdInUrl = urlToClean.searchParams.get('id');
      urlToClean.search = '';
      if (activityIdInUrl) urlToClean.searchParams.set('id', activityIdInUrl);
      history.replaceState(null, '', urlToClean.toString());
    }
  }

  if (sessionStorage.getItem("id_token")) {
    // 已登入：取得使用者資料
    let t_data = jwtDecode(sessionStorage.getItem("id_token"));
    tmdid.value = t_data.sub;
    ecName.value = sessionStorage.getItem("open_name");
    ecEmail.value = sessionStorage.getItem("open_mail");

    // 載入活動資料（同時建立 groupListInfo）
    await fetchEventData(eventId);
    await syncUserSchoolByEventSchoolId();
    // 若活動 target 為 schoolClass，以 schoolId 呼叫 API 取得老師與班級名單
    await initSchoolClassData();
    // 根據模式決定課程來源（一般模式：IES；schoolClass 模式：班級名單）
    await getIes5dataFun();
    // 取得已報名統測教師課程及組別（需在fetchEventData之後，因為需要 groupListInfo 的資料）
    await getActiveData();

    // 登入後，若無報名資料，且報名時間未結束，則跳出提示訊息
    if (applyInfoData.length === 0 && isPC.value && ActiveStart.value && isInSignUpStage.value && !isSignUpClosed.value && !shouldHideJoinEntry.value) {
      dialogAfterLoginCtrl.value = true;
    }

    await setJointData();

    // 取得使用者電子郵件
    if (localStorage.getItem("profile")) {
      let localeProfile = JSON.parse(localStorage.getItem("profile"));
      userSchoolRowData = await api.main.getTmidInfo({ tmid: localeProfile.id, jointEventId: ActivityID.value });
      signUpEmail.value = userSchoolRowData.tmidInfo?.mail || '';
      if (!userSchoolRowData.tmidInfo?.mail) {
        isSaveMainEmail.value = true;
        isMustSaveMainEmail.value = true;
      }
    }
  } else {
    // 未登入：只載入活動資料
    await fetchEventData(eventId);
    await syncUserSchoolByEventSchoolId();
  }
  
});

onUnmounted(() => {
  window.removeEventListener('resize', handleResize);
});

// 監聽路由變化
watch(() => route.query.id, async (newId) => {
  if (newId) {
    await fetchEventData(newId);
    await syncUserSchoolByEventSchoolId();
    if (sessionStorage.getItem("id_token")) {
      await initSchoolClassData();
      await getIes5dataFun();
      await getActiveData();
      await setJointData();
    }
  }
});
</script>

<style lang="less" scoped>
@fontColor: #424f55;
@fontColor-light: #8da3a0;
@stressColor: #f59f56;
@fontColor-gray1: #909399;
@fontColor-gray2: #b1b3b8;
@other-blue: #70a6b2;
@background-gray: #eff4f7;

// Loading 覆蓋層
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  
  p {
    margin-top: 20px;
    font-size: 16px;
    color: @fontColor;
  }
}

// 表單容器
.form-container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px 30px;
}

.signup-form-wrap {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 2px 0;
  width: 100%;
}

.signup-info-group {
  background: #f5f9ff;
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.signup-field-row {
  display: flex;
  align-items: baseline;
  gap: 12px;
}

.signup-field-label {
  font-size: 13px;
  color: #888;
  white-space: nowrap;
  min-width: 110px;
}

.signup-field-value {
  font-size: 15px;
  font-weight: 600;
  color: #2c3e50;
  word-break: break-all;
}

.form-item {
  margin-bottom: 28px;
  font-size: 16px;
}

.form-item strong {
  display: block;
  margin-bottom: 10px;
  font-weight: 600;
}

.input-email {
  margin-bottom: 5px;
}

.input-width {
  width: 80%;
}

/deep/.el-cascader.input-width {
  width: 80%;
}

.spanTotal {
  border-right: solid;
  margin-right: 15px;
  border-color: lightgrey;
}

.spanTotal2 {
  font-weight: 600;
  font-size: 16px;
  text-decoration: none;
  align-items: flex-end;
  display: flex;
}

.signup-dialog-footer {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

// /deep/ .el-dialog__header.show-close {
//   padding-right: 0px !important;
// }

/deep/ .el-dialog.login-dialog {
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  background-color: #fff;
}

.login-dialog-header {
  padding: 10px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  border-radius: 10px 10px 0 0;
  border-bottom: solid;
  border-color: gainsboro;
}

.login-dialog-content {
  margin-top: 20px;
  padding: 15px;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  color: #444;
}

.title_school {
  font-weight: bold;
  font-size: 25px;
  margin-top: auto;
}

.a_color {
  color: @stressColor;
  cursor: pointer;
}

.otheBlueColor {
  color: @other-blue;
}

.stressColor {
  color: @stressColor;
}

.gray1Color {
  color: @fontColor-gray1;
}

.highlight-row {
  background-color: #fef0f0;
  color: #f56c6c;
  padding: 2px 8px;
  border-radius: 4px;
  margin-left: 10px;
  font-size: 12px;
}

.current_progress {
  color: @stressColor;
  font-size: 12px;
  background: #fff3e0;
  padding: 2px 8px;
  border-radius: 4px;
}

// 活動資訊區域
// .ActiveAllInfo {
//   position: relative;
//   margin-top: 10px;

//   .ActiveTitle {
//     font-size: 70px;
//     margin-bottom: 10px;

//     &.PC {
//       font-size: 37px;
//     }
//   }

//   .ActiveInfoDiv {
//     margin-top: 10px;

//     @media (max-width: 1250px) {
//       display: flex;
//       align-items: center;
//       flex-direction: column;
//     }

//     .ActivePic {
//       width: 250px;
//       height: 250px;

//       .pic {
//         width: 100%;
//         height: 100%;
//         object-fit: contain;
//       }
//     }

//     .titleContentArea {
//       margin-left: 20px;

//       .otherInfoArea {
//         flex: 1;
//         min-width: 250px;
//         max-width: 300px;
//         margin-bottom: 20px;

//         .Replenish {
//           color: @fontColor-gray1;
//           font-style: oblique;
//         }

//         @media (max-width: 1090px) {
//           margin: 50px 20px;
//         }
//       }
//     }
//   }
// }
.ActiveAllInfo{
    position: relative;
    margin-top: 10px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    // 背景圖優先使用 template 透過 :style 注入的 CSS 變數。
    // 第二參數是保底值：若變數不存在（例如 SSR/異常渲染）時仍使用 001。
    background-image: var(--main-visual-bg-image, url("../../assets/img/mainvisual/001.png"));
    background-repeat: no-repeat;
    background-size: contain;
    background-position: top center;
    padding: 5% 0;
    @media (max-width: 768px) {
      background-image: none;
    }
    .ActiveTitle{
      // font-weight:bold;//粗體
      font-size: 60px;
      margin-bottom: 10px;
      &.PC{
        font-size: 37px
      }
    } 
    .ActiveInfoDiv{
      // width: 90%;
      margin-top: 10px;
      align-items: center;
      @media (max-width: 1250px) {
        display: flex;    
        align-items: center;
        flex-direction: column;
      }
      .ActivePic{
        width: 250px;
        height: 250px;
        .pic{
          width: 100%;
          height: 100%;
          // object-fit: cover;
          object-fit: contain;//確保整張圖被看見
        }
      }  
      .titleContentArea{
        margin-left: 20px;
        // .ActiveTitle{
        //   font-weight:bold;//粗體
        //   font-size: 30px;
        //   margin-bottom: 10px;
        // }  
        .otherInfoArea{
          flex: 1;        
          min-width: 250px;
          max-width: 300px;
          margin-bottom: 20px;

          .activity-introduction-content {
            line-height: 1.8;
            word-break: break-word;

            p:first-child {
              margin-top: 0;
            }

            p:last-child {
              margin-bottom: 0;
            }

            a {
              color: @stressColor;
            }
          }

          .Replenish{
            color:@fontColor-gray1;
            font-style:oblique;
          }
          @media (max-width: 1090px) {
            margin: 50px 20px;
          }
        }  
      }
    }  
  }

// 按鈕區域
.joinButtonArea {
  margin-top: 30px;

  .joinButton {
    align-items: center;
    border-radius: 50px;
    font-size: 20px;
    font-weight: bold;
    width: 200px;
    height: 50px;
    background: @fontColor-gray1;
    cursor: no-drop;
    display: flex;
    justify-content: center;
    align-items: center;

    .txt {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    &.downLoad {
      background-color: @other-blue;

      &.load {
        cursor: pointer;
      }

      &.PC {
        margin-right: 20px;
      }
    }

    &.mar-right {
      &.PC {
        margin-right: 20px;
      }
    }

    &.onClick {
      background: @stressColor;
      cursor: pointer;
    }

    &.disabled {
      background: #ccc;
      color: #666;
      cursor: not-allowed;
      opacity: 0.6;
    }
  }
}

// 內容區域
.cotentDiv {
  max-width: 1200px;
  width: 100%;
  padding: 20px;
}

.tableDiv {   
  width: 90%;
  max-width: 1200px;
  margin-top: 50px;
  
  .info {
    display: flex;
    align-items: end;
  }
  
  &.class {
    margin-bottom: 50px;
  }
  
  &.planDiv {
    margin-bottom: 100px;
  }
  
  ::v-deep .info-cell {
    white-space: normal;
    word-wrap: break-word;
    text-align: left;
  }
  
  .titleDiv {
    margin-bottom: 10px;
    
    .title {
      font-weight: bold;
      font-size: 25px;
      text-decoration: underline;
      margin-top: auto;
      
      .iconPic {
        width: 50px;
        margin-right: 10px;
      }
    }
  }
  
  &.left {
    flex: 1;
  }
  
  &.right {
    width: 100%;
    margin-left: 0px;
  }
}

.titleDiv {
  margin-bottom: 15px;
  
  .title {
    font-size: 18px;
    font-weight: bold;
    color: @fontColor;
    
    .iconPic {
      width: 24px;
      //height: 24px;
      margin-right: 8px;
    }
  }
}

// 得獎區域
.winCotent {
  margin-top: 20px;
  
  .ContestTitle {
    font-size: 16px;
    font-weight: bold;
    color: @fontColor;
    margin-bottom: 10px;
    padding: 8px 16px;
    background: #f5f7fa;
    border-radius: 4px;
  }
}

.tableCss, .tableCssPhone {
  margin-bottom: 15px;
}

.winTxt {
  margin-left: 8px;
  font-weight: 600;
}

// 學校列表
.schoolList {
  .list {
    padding: 8px 0;
    font-size: 16px;
    
    .iconPic {
      width: 20px;
      height: 20px;
      margin: 0 8px;
    }
  }
}

// 表單提醒
.award-form-notice-pc,
.award-form-notice-mobile {
  background: #fff3e0;
  padding: 30px;
  border-radius: 12px;
  text-align: center;
  max-width: 800px;
  
  .form-link-decoration {
    font-size: 24px;
  }
}

// 時程區域
.scheduleArea {
  margin-bottom: 20px;
  
  .titleArea {
    margin-bottom: 10px;
    
    .stepName {
      font-size: 18px;
      font-weight: bold;
    }
  }
  
  .card {
    background: #f5f7fa;
    padding: 15px;
    border-radius: 8px;
    
    .place, .time {
      margin-bottom: 8px;
    }
    
    .description {
      color: @fontColor-gray1;
    }
  }
  
  .triangleArea {
    padding: 10px 0;
    
    .triangle {
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-top: 15px solid @other-blue;
    }
  }
}

// 頁尾
.footerDiv {
  background: @background-gray;
  padding: 30px;
  margin-top: 40px;
  
  .txtDiv {
    max-width: 1200px;
    line-height: 1.8;
    font-size: 14px;
    color: @fontColor-gray1;
  }
  
  &.phone {
    padding: 20px;
    
    .txtDiv {
      font-size: 12px;
    }
  }
}

// 對話框
.dialog-header {
  display: flex;
  align-items: center;
  padding-bottom: 10px;
  margin-left: -24px;
  margin-right: -24px;
  padding-left: 24px;
  padding-right: 24px;
  //border-bottom: 2px solid #f0d9bc;
  
  .iconPic {
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }
  
  .title {
    font-size: 18px;
    font-weight: bold;
  }
}

.applyTableDiv {
  .content {
    padding: 20px;
    
    .info {
      background: #d6eaf8;
      padding: 15px;
      border-radius: 8px;
      margin-bottom: 20px;
      line-height: 1.8;
      border-left: 4px solid #2e86c1;
    }
    
    .school-header {
      // background: #ebf5fb;
      margin-bottom: 15px;
      padding: 12px;
      border-radius: 8px;
      // border: 1px solid #a9cce3;
      
      .title {
        font-size: 20px;
        font-weight: bold;
        color: #424f55;
      }
      
      .editButton {
        margin-left: 10px;
      }
    }
    
    .chooseArea2 {
      background: #f5f9ff;
      margin-bottom: 15px;
      padding: 12px;
      border-radius: 8px;
    }
  }
}

// 通用類別
.div-center{/*水平置中*/
  display: flex; 
  justify-content: center; 
  text-align:center;
  width:100%;
}
.div-center2{
  margin-right: auto;
  margin-left: auto;
}
.div-centerY{ /*垂直置中*/
  display: flex;    
  align-items: center;
  flex-direction: column;  //有時可能需要在加這個屬性
  &.YUnset{
    flex-direction: unset;  
  }
}
.div-centerY2{ /*垂直置中*/
  margin-top: auto;
  margin-bottom: auto;
}

.oneLine {
  display: flex;
  align-items: center;
}

.between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left {
  text-align: left;
}

.cursorPointer {
  cursor: pointer;
}

.whiteColor {
  color: white;
}

.picButton {
  position: relative;
  cursor: pointer;
  margin-top: 10px;
  width: 200px;
  height: 35px;

  &.big {
    width: 200px;
    height: 50px;
  }

  .buttonImg {
    height: 100%;
    width: 100%;
    display: block;
  }

  .pngText {
    font-size: 16px;

    &.big {
      font-size: 20px;
    }

    transform: translate(0%, -130%);
    color: white;
    font-weight: bold;
    text-align: end;
  }

  .txt {
    font-size: 20px;
    font-weight: bold;
  }
}

.signUpButton {
  background: @stressColor;
  border-color: @stressColor;
  color: white;
}

.urlCss {  
  color: #409EFF;
  font-weight: bold;
  text-decoration: none;
  transition: 0.3s;
}

.line {
  height: 1px;
  background: #eee;
  margin: 10px 0;
}

// 表格背景
/deep/ .tableBackground {
  background-color: #fff8e1 !important;
}

// 普通表格樣式
.scheduleTable {
  width: 100%;
  border-collapse: collapse;
  background-color: #fff;
  
  thead {
    background-color: transparent;
  }
  
  th {
    color: #999;
    padding: 12px 15px;
    text-align: left;
    border-bottom: 1px solid #999;
    font-weight: bold;
    font-size: larger;
  }
  
  td {
    padding: 12px 15px;
    text-align: left;
    border-bottom: 1px solid #999;
  }
  
  tbody tr {
    &:hover {
      background-color: #f5f7fa;
    }
  }
  
  tbody tr.highlight-row {
    background-color: #F59F56;
    color: #fff;
  }
}

// RWD
@media (max-width: 768px) {
  .cotentDiv {
    padding: 10px;
  }
}

</style>

<!-- 班級管理對話框主題：el-dialog teleport 至 body，須使用非 scoped 樣式 -->
<!-- ?style=sky   清新天空藍 -->
<!-- ?style=sage  自然鼠尾草綠 -->
<!-- ?style=warm  溫暖奶茶米白 -->
<!-- ?style=candy 糖果風 (保留) -->
<!-- ?style=ocean 海洋風 (保留) -->
<!-- ?style=game  遊戲風 (保留) -->
<style lang="less">

// ──────────────────────────────────────────────
// 純 HTML 卡片風格列表 (對話框內使用)
// ──────────────────────────────────────────────
.cardListContainer {
  width: 100%;
  overflow-y: auto;
  max-height: 400px;
  padding: 0;
  position: relative;
}

.cardListHeader {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1.5fr 1fr 1.8fr;
  gap: 16px;
  padding: 16px 20px;
  background: transparent;
  margin-bottom: 12px;
  position: sticky;
  top: 0;
  z-index: 20;
  font-weight: 700;
  font-size: 13px;
  color: #666;
  text-align: left;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #eee;
}

.cardListBody {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.cardListContainer.hide-edit-column .cardListHeader,
.cardListContainer.hide-edit-column .cardRow {
  grid-template-columns: 2fr 1fr 1fr 1fr 1.8fr;
}

.cardRow {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1.5fr 1fr 1.8fr;
  gap: 16px;
  padding: 16px 20px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border: 1px solid #e8e8e8;
  align-items: center;
}

.cardRow:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}

.cardColumn {
  display: flex;
  align-items: center;
  gap: 8px;
}

.class-manage-card-list .cardListHeader {
  font-size: 14px;
}

.class-manage-card-list .cardRow {
  font-size: 15px;
}

.class-manage-card-list .btn {
  font-size: 13px;
  padding: 6px 12px;
  border-radius: 999px !important;
}

.class-manage-card-list .col-edit .el-button {
  border-radius: 999px;
}

// 按鈕樣式 (純 HTML 按鈕替代 el-button)
.btn {
  padding: 4px 10px;
  font-size: 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
}

.btn:hover {
  opacity: 0.9;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}

.btn-primary {
  background: #3a90d4;
  color: white;
}

.btn-primary:hover {
  background: #2970be;
}

.btn-secondary {
  background: #e6a23c;
  color: white;
}

.btn-secondary:hover {
  background: #cc8f1f;
}

.btn-warning {
  background: #f59f56;
  color: white;
}

.btn-warning:hover {
  background: #e07d3e;
}

.btn-danger {
  background: #f56c6c;
  color: white;
}

.btn-danger:hover {
  background: #f04c4c;
}

.btn-small {
  padding: 4px 8px;
  font-size: 11px;
}

// ──────────────────────────────────────────────
// 班級管理對話框預設樣式 (溫暖奶茶米白)
// ──────────────────────────────────────────────

.applyTableDiv {  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(66,79,85,0.14) !important;

  .el-dialog__header {
    background: transparent;
    padding: 16px 24px;
    .title {
      color: #424f55;
      font-size: 18px;
      font-weight: 700;
    }
    .el-dialog__headerbtn .el-icon { color: #f59f56 !important; }
  }

  .content .info {
    background: #d6eaf8;
    border-left: 4px solid #2e86c1;
    border-radius: 8px;
    color: #424f55;
    font-size: 14px;
  }

  .school-header .title { color: #424f55; font-size: 20px; font-weight: 700; }



  .class-dialog-full-underline {
    position: relative;
  }

  .class-dialog-full-underline::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 2px;
    background: #f5c98b;
    border-radius: 2px;
  }

  .class-create-dialog-header.dialog-header {
    margin-left: 0;
    margin-right: 0;
    width: 100%;
    box-sizing: border-box;
    justify-content: center;
  }


  .chooseArea2 > div > span {
    background: #fdecd6 !important;
    color: #424f55 !important;
    padding: 3px 14px;
    border-radius: 6px;
    font-weight: 600;
    border: 1px solid #f5c98b;
  }

  .cardListHeader {
    background: #fae6cb !important;
    color: #424f55 !important;
  }

  .chooseArea2 .el-button--primary,
  .btn-primary {
    background: #f59f56 !important;
    border: none !important;
    border-radius: 6px;
    font-weight: 600;
  }

  .highlight-row {
    background: #d8edf0 !important;
    color: #2f7580 !important;
    border: 1px solid #9dcbd2;
    border-radius: 5px;
  }

  .btn-action-edit {
    background: #84c2ba !important;
    color: #fff !important;
  }

  .btn-action-edit:hover {
    background: #6ba59e !important;
  }

  .btn-action-cancel {
    background: #f58f8f !important;
    color: #fff !important;
  }

  .btn-action-cancel:hover {
    background: #ef7a7a !important;
  }

  .btn-action-signup {
    background: #61a8df !important;
    color: #fff !important;
  }

  .btn-action-signup:hover {
    background: #4f95cb !important;
  }
}

// 報名視窗：強制 body 撐滿寬（因 div-centerY 的 align-items:center 會收縮子元素）
.signup-dialog .el-dialog__body {
  width: 80%;
  box-sizing: border-box;
}

.create-class-dialog .el-dialog__header {
  width: 100%;
  box-sizing: border-box;
}

// ──────────────────────────────────────────────
// 新增/變更班級 步驟式佈局
// ──────────────────────────────────────────────
.createClass-step {
  width: 100%;
  margin-bottom: 18px;
}

.createClass-step-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 700;
  color: #2e86c1;
  margin-bottom: 10px;
  border-bottom: 2px solid #d6eaf8;
  padding-bottom: 8px;
  width: 100%;
}

.step-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  background: #2e86c1;
  color: #fff;
  border-radius: 50%;
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
}

.createClass-name-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.createClass-course-tag {
  background: #2e86c1;
  color: #fff;
  padding: 4px 14px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
}

.createClass-dash {
  color: #888;
  font-size: 18px;
}

.createClass-hint-body {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  flex-wrap: wrap;
}

.createClass-hint-text {
  flex: 1;
  font-size: 14px;
  line-height: 2;
  color: #424f55;
}

.createClass-hint-img {
  flex-shrink: 0;
  position: relative;
}

.hint-img-zoom {
  cursor: zoom-in;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  transform-origin: center center;
}

.hint-img-zoom:hover {
  transform: scale(2.8);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  z-index: 100;
  position: relative;
}

.createClass-editor {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-top: 10px;
}

.createClass-editor-col {
  flex: 1;
}

.createClass-col-label {
  font-size: 13px;
  font-weight: 600;
  color: #2e86c1;
  margin-bottom: 6px;
}

.createClass-editor-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 30px;
}

.createClass-add-btn {
  white-space: nowrap;
  font-size: 13px;
  padding: 8px 14px;
}

</style>
